import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ignoreElements } from 'rxjs/operators';
import { AppConstant } from 'src/app/config/app.constant';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { DateService } from 'src/app/services/date.service';
import { facilityService } from 'src/app/services/facility.service';
import { ParkService } from 'src/app/services/park.service';
import { SidenavService } from 'src/app/services/sidenav.service';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { log } from 'console';
import { MeetingService } from 'src/app/services/meeting.service';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CompanyService } from 'src/app/services/company.service';
import { XssValidationService } from 'src/app/services/xss-validation.service';

@Component({
  standalone: false,
  selector: 'app-create-meeting-room',
  templateUrl: './create-meeting-room.component.html',
  styleUrls: ['./create-meeting-room.component.scss']
})
export class CreateMeetingRoomComponent implements OnInit {
  @ViewChild('contentSecurity', { static: false }) contentSecurity: ElementRef;
  @ViewChild('contentMeetingRoom', { static: false }) contentMeetingRoom: ElementRef;
  @ViewChild('contentBooking', { static: false }) contentBooking: ElementRef;
  @ViewChild('myInputField', { static: false }) myInputField: any;
  @ViewChild('descriptionmeetingroom', { static: false }) descriptionmeetingroom: ElementRef;
  @ViewChild('myForm', { static: false }) myForm!: ElementRef;

  propertyType: boolean;
  mobile: boolean;
  propertyName: boolean;
  address: boolean;
  url: any[] = [];
  email: any;
  propTypeId: any;
  propType: any;
  tncList: any[] = [{ id: 1 }];
  policyList: any[] = [{ id: 1 }];
  calcList: any[] = [{ id: 1 }];
  contactDetails: any[] = [{ mobileNo: '', email: '' }];
  selectedDate: any;
  formatDate: any;
  selectedToDate: any;
  formatToDate: any;
  sDate: boolean;
  eDate: boolean;
  minDate = undefined;
  fDate: any;
  tDate: any;
  amt: boolean;
  showSecurity: boolean;
  showMeetingRoom: boolean;
  showBooking: boolean;
  value: any = 10;
  type: any;
  showCal: boolean = false;
  showPolicy: boolean = true;
  hourR: boolean;
  hourRate: any;
  hourAdditional: any;
  dailyR: boolean;
  dailyRate: any;
  dailyAdditional: any;
  amtDeducted: boolean;
  min: boolean;
  unitType: boolean;
  unitTypeList: any = [];
  unit: any;
  time1: boolean;
  time2: boolean;
  amorpm: boolean = false;
  amorpm1: boolean = true;
  tempTime: any;
  tempEndTime: any;
  meridian: any;
  startTimePlaceholder: string;
  endTimePlaceholder: string;
  startTime = { hour: 7, minute: 0 };
  endTime = { hour: 7, minute: 0 };
  meetingRoomId: any;
  MeetingRoomDetails: any;
  roomName: string;
  meetingRoomType: string;
  description: string;
  securityDeposit: Number;
  securityDepositVal: boolean = false;
  capacity: number = 1;
  minbookingDuration: number = 0.5;

  meetingRoomCapacilty: number;
  additonalHourRate: number;
  TempMeetingRoomPolicies: any[] = [];
  meetingRoomPolicies: any[] = [];
  meetingRoomPolicy: any[] = [];
  policies: any[];
  meetingRoomTnc: any[] = [];
  TempMeetingRoomTnc: any[] = [];
  TempMeetingRoomContacts: any[] = [];
  meetingRoomContacts: any[] = [];
  meetingRoomImages: any[] = [];
  TempMeetingRoomImages: any[] = [];
  meetingRoomCanCal: any[] = [];
  TempMeetingRoomCanCal: any[] = [];
  contacts: any[];
  images: any;
  Cancal: any[];
  TnC: any;
  meetingRoomTypeId: any;
  ParkId: any;
  MeetingRoomDetailsResultt: any;
  meetingRoomCanCalDetails: any;
  HeaderMeetingRoomName: string;
  hourAdd: any;
  dailyAdd: any;
  errSecurity: boolean;
  showError: boolean;
  errName: boolean;
  errDes: boolean;
  errorText: string;
  error: any = [];
  mdate: any;
  mend: any;
  todayDate: string;
  nextDate: string;
  buttonType: string;
  gstDetail: any;
  meetingRoomName: string;
  spaceOnRent: boolean = false;
  zoneId: any;
  closeResult: string;
  activation: any;
  statusText: string;
  toggleType: any;
  meetingRoomCapaciltyVal: boolean = false;
  bookingCapaciltyVal: boolean = false;
  minBookingDurationVal: boolean = false;
  inValidText: string = '';
  zoneVal: string;
  popTitle = 'Title';
  time = { hour: 13, minute: 30 };
  timepickeropen: boolean = false;
  isAllDay: boolean = false;
  selectedDaily: boolean = false;
  selectedWeekly: boolean = false;
  selectedMonthly: boolean = false;
  selectedYearly: boolean = false;
  selectedDailyClick: boolean = false;
  selectedWeeklyClick: boolean = false;
  selectedMonthlyClick: boolean = false;
  selectedYearlyClick: boolean = false;
  step: number;
  weeklyValueRequired: boolean = true;
  timeFieldDisabled: boolean = false;

  TempRateCardHourCal: any[] = [];
  TempRateCardHourCalDelete: any[] = [];
  deleteTimeWithHour = { hour: 0, minute: 0 };
  deleteamorpm: boolean = false;
  startTimePlaceholderRate: string;
  endTimePlaceholderRate: string;
  startTimeRate = { hour: 7, minute: 0 };
  endTimeRate = { hour: 7, minute: 0 };
  times: NgbTimeStruct[] = [];
  tempTimeRate: any;
  tempEndTimeRate: any;
  popupcontent = 'popContent60';
  stimerate: any;
  etimerate: any;
  daysOfOperation = [];
  fromDaysOperation: any;
  toDaysOperation: any;
  errFromDayOperation: boolean;
  errToDayOperation: boolean;
  amorpm2: boolean = false;
  amorpm3: boolean = false;
  timeSlabRate: any[];
  rateCardAllTimeSum: any;
  dailyRateCardAllTimeSum: any;
  stimeratePlaceHolder: any;
  etimeratePlaceHolder: any;

  startDateMaintainence: any;
  endDateMaintainence: any;
  startTimeMaintainence: any;
  endTimeMaintainence: any;
  amorpm4: boolean = false;
  amorpm5: boolean = false;
  startTimePlaceholderMaint: string;
  endTimePlaceholderMaint: string;
  startTimeMaintenance = { hour: 7, minute: 0 };
  endTimeMaintenance = { hour: 7, minute: 0 };
  startDateOfMaintenance: any;
  endDateOfMaintenance: any;
  errstartDateOfMaintenance: boolean;
  errendDateOfMaintenance: boolean;
  errOperationHours: boolean = false;
  selectedDateMainten: any;
  formatDateMainten: any;
  selectedToDateMainten: any;
  formatToDateMainten: any;
  mtstime: any;
  mtetime: any;
  theMethodOfRepete = [];
  repeatEvery: any;
  repeatEveryText: any;
  minRepeat: any;
  maxRepeat: any;
  stepRepeat: any;
  repeatEveryType: number = 1;
  endOfRepeate: any;
  selectedWeekNames: any;
  weeksOfOperation = [];
  repeateTestPlaceHolder: boolean = false;
  mtsDate: boolean;
  mteDate: boolean;
  monthlyRepeatOnChecked: boolean = true;
  monthlyRepeatOnCheckedWeekName: boolean = true;
  monthlyRepeateOnModel: any;
  weekNameArray = [];
  repeatTypeValue: any;
  monthDateValueModel: any;
  monthAllDate = [];
  monthlyRepeateOnWeekName: any;
  monthlyRepeateOnWeekStarting: any;
  monthSratingPoint = [];
  minMaintDuration: number = 1;
  monthsOfOperation = [];
  monthsOfOperationModel: any;
  finalMaintenaceCalArray: any[] = [];
  selectFromDateMt: any;
  selectToDateMt: any;
  finalDailyStartTime: any;
  finalDailyEndTime: any;
  aminitiesList: any;
  amentities: any = [];
  selectedAminity: any[] = [];
  parkMeetingRoomAmenities: { AmenitiesId: any; }[];
  previewUrl: any = null;
  errorMessage: string = '';

  parkTenantId: string;
  parkId: string = localStorage.getItem('parkId');
  myCompanyData: any = [];
  employeeList: any = [];
  employeeListActive: any = [];
  companyTenantAdminId: any;
  taId: string;
  minAutoCancelDuration: number = 5;
  minAutoCancelDurationVal: boolean = false;
  isWeekDaysOperation: boolean;
  maxbookingDuration: number = 0.5;
  maxBookingDurationVal: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private parkSrv: ParkService,
    private appStateSrv: AppStateProvider,
    private dateSrv: DateService,
    public datepipe: DatePipe,
    private dateAdapter: NgbDateAdapter<string>,
    private ngbCalendar: NgbCalendar,
    private apiSrvice: facilityService,
    private modalService: NgbModal,
    private sideNavService: SidenavService,
    private el: ElementRef,
    private meetingService: MeetingService,
    private rolebasedactionService: RolebasedactionService,
    private sanitizer: DomSanitizer,
    private companyService: CompanyService,
    private xssValidation: XssValidationService,
  ) {
    this.meetingRoomName = localStorage.getItem('meetingRoomName');

    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };
    this.meetingRoomCapacilty = 1;
  }

  ngOnInit() {
    this.parkTenantId = localStorage.getItem('tenantAdminId');
    console.log('parkTenantId', this.parkTenantId);
    this.rateCardAllTimeSum = 0;
    this.dailyRateCardAllTimeSum = 0;
    this.popupcontent = 'popContent60';
    this.endOfRepeate = 'neverRepeateMaint';
    this.monthlyRepeatOnChecked = true;
    this.monthlyRepeatOnCheckedWeekName = false;
    this.monthlyRepeateOnModel = "1";
    this.monthlyRepeateOnWeekName = "1";
    this.monthDateValueModel = "1";
    this.monthlyRepeateOnWeekStarting = "0";
    this.dailyRate = 0;
    this.dailyAdditional = 0;

    this.onTimeChange(this.startTime);
    this.onTimeChange1(this.endTime);
    //this.onTimeChangeRateCard(this.startTimeRate, 0);
    //this.onTimeChangeRate1(this.endTimeRate, 0);

    this.activatedRoute.queryParams.subscribe((res) => {

      this.meetingRoomId = res.meetingRoomId;
      this.meetingRoomTypeId = res.meetingRoomTypeId;

      if (this.meetingRoomId != null) {
        // this.getGSTDetail();
        this.setInputState();
        this.buttonType = 'Save';
        this.HeaderMeetingRoomName = 'Update Meeting Room';
        this.clearArrays();
        // this.getMeetingRoomDetails(this.meetingRoomId);
        this.GetCancalUnitFordropdown();
        this.getMyCompanyDetails();
        this.getMeetingRoomDetails(this.meetingRoomId);
      } else {
        // this.getGSTDetail();
        this.getGSTDetail('sez');
        this.buttonType = 'Add';
        this.HeaderMeetingRoomName = 'Create New Meeting Room';
        this.LoadDataForAddMeeting();
        this.GetCancalUnitFordropdown();
        this.getMyCompanyDetails();
      }
    });

    console.log('id', this.meetingRoomId);

    this.type = 'pol';
    const jsDate = new Date();

    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formatDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formatToDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );

    this.selectedDateMainten = ''; // this.datepipe.transform(jsDate, 'yyyy-MM-dd');
    this.formatDateMainten = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.selectedToDateMainten = ''; // this.datepipe.transform(jsDate, 'yyyy-MM-dd');
    this.formatToDateMainten = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );

    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();

    this.fromDaysOperation = '';
    this.toDaysOperation = '';
    this.companyTenantAdminId = '';
    this.daysOfOperation.push(
      {
        id: "1",
        name: "Monday",
      },
      {
        id: "2",
        name: "Tuesday",
      },
      {
        id: "3",
        name: "Wednesday",
      },
      {
        id: "4",
        name: "Thursday",
      },
      {
        id: "5",
        name: "Friday",
      },
      {
        id: "6",
        name: "Saturday",
      },
      {
        id: "0",
        name: "Sunday",
      }
    );
    this.repeatEvery = '0';
    this.selectedDaily = true;
    this.repeatEveryText = 'Day(s)';
    this.theMethodOfRepete.push(
      {
        id: "0",
        name: "Daily"
      },
      {
        id: "1",
        name: "Weekly"
      },
      {
        id: "2",
        name: "Monthly"
      },
      {
        id: "3",
        name: "Yearly"
      }
    );

    this.weeksOfOperation.push(
      {
        id: "1",
        name: "Monday",
        selected: false
      },
      {
        id: "2",
        name: "Tuesday",
        selected: false
      },
      {
        id: "3",
        name: "Wednesday",
        selected: false
      },
      {
        id: "4",
        name: "Thursday",
        selected: false
      },
      {
        id: "5",
        name: "Friday",
        selected: false
      },
      {
        id: "6",
        name: "Saturday",
        selected: false
      },
      {
        id: "0",
        name: "Sunday",
        selected: false
      }
    );
    this.monthAllDate = [];
    for (let k = 1; k <= 31; k++) {
      this.monthAllDate.push(
        {
          id: k,
          name: k
        }
      );
    }
    this.monthSratingPoint.push(
      {
        id: "0",
        name: "First",
      },
      {
        id: "1",
        name: "Second",
      },
      {
        id: "2",
        name: "Third",
      },
      {
        id: "3",
        name: "Fourth",
      },
      {
        id: "4",
        name: "Last",
      },
    );

    this.monthsOfOperationModel = "0";
    this.monthsOfOperation.push(
      {
        id: "0",
        name: "January",
      },
      {
        id: "1",
        name: "February",
      },
      {
        id: "2",
        name: "March",
      },
      {
        id: "3",
        name: "April",
      },
      {
        id: "4",
        name: "May",
      },
      {
        id: "5",
        name: "June",
      },
      {
        id: "6",
        name: "July",
      },
      {
        id: "7",
        name: "August",
      },
      {
        id: "8",
        name: "September",
      },
      {
        id: "9",
        name: "October",
      },
      {
        id: "10",
        name: "November",
      },
      {
        id: "11",
        name: "December",
      }
    );
    this.getAllAminities();
  }

  async getGSTDetail(type) {
    if (this.gstDetail == null) {
      await this.apiSrvice.getGSTDetail().subscribe((res) => {
        console.log(res);
        this.gstDetail = res;
        this.selectZone(type);
      });
    } else {
      this.selectZone(type);
    }
  }

  togglePopup(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  setInputState() {
    this.eDate = true;
    this.sDate = true;
    this.time2 = true;
    this.time1 = true;
    this.email = true;
    this.mobile = true;
    this.min = true;
    this.unitType = true;
    this.amtDeducted = true;
    this.dailyAdd = true;
    this.dailyR = true;
    this.hourAdd = true;
    this.propertyType = true;
    this.propertyName = true;
    this.amt = true;
    this.hourR = true;
    this.mtsDate = true;
    this.mteDate = true;
    this.repeateTestPlaceHolder = true;
    this.stimeratePlaceHolder = true;
    this.etimeratePlaceHolder = true;
  }

  clearArrays() {
    console.log('clearArrays');
    this.TempMeetingRoomPolicies = [];
    this.meetingRoomPolicies = [];
    this.meetingRoomPolicy = [];
    this.policies = [];
    this.meetingRoomTnc = [];
    this.TempMeetingRoomTnc = [];
    this.TempMeetingRoomContacts = [];
    this.meetingRoomContacts = [];
    this.meetingRoomImages = [];
    this.TempMeetingRoomImages = [];
    this.meetingRoomCanCal = [];
    this.TempMeetingRoomCanCal = [];
    this.contacts = [];
    this.images = [];
    this.Cancal = [];
    this.TempRateCardHourCal = [];
    this.timeSlabRate = [];
    this.finalMaintenaceCalArray = [];
  }

  private appendArrayToFormData(formData: FormData, name: string, arr: any[]): void {
    if (!arr || !Array.isArray(arr)) {
      formData.append(name, '[]');
      return;
    }
    if (arr.length === 0) {
      formData.append(name, '[]');
      return;
    }
    for (let i = 0; i < arr.length; i++) {
      const obj = arr[i];
      if (obj == null || typeof obj !== 'object') continue;
      for (const key of Object.keys(obj)) {
        const v = obj[key];
        const base = name + '[' + i + '].' + key;
        if (v === null || v === undefined) {
          formData.append(base, '');
        } else if (Array.isArray(v)) {
          for (let j = 0; j < v.length; j++) {
            const item = v[j];
            const itemVal =
              item === null || item === undefined
                ? ''
                : typeof item === 'object'
                  ? JSON.stringify(item)
                  : String(item);
            formData.append(base + '[' + j + ']', itemVal);
          }
        } else if (typeof v === 'object') {
          formData.append(base, JSON.stringify(v));
        } else {
          formData.append(base, String(v));
        }
      }
    }
  }

  LoadDataForAddMeeting() {
    this.ParkId = localStorage.getItem(AppConstant.localStorage.parkId);
    this.mtstime = null;
    this.mtetime = null;
    const data = {
      meetingRoomCancellationCalculationId: null,
      isActive: true,
      timePrior: '0',
      unitType: null,
      amountDeducted: 0,
    };
    const data2 = {
      meetingRoomContactId: null,
      contactNumber: null,
      contactEmail: null,
      meetingRoomId: null,
    };
    const data3 = {
      meetingRoomPolicyId: null,
      policyDescription: null,
      meetingRoomId: null,
    };
    const data4 = {
      isActive: true,
      meetingRoomTncid: null,
      termDescription: null,
      meetingRoomId: null,
    };
    const data5 = {
      parkMeetingRoomTimeSlabListId: null,
      isActive: true,
      hourRate: 0,
      stimerate: null,
      etimerate: null,
    };
    this.meetingRoomTnc.push(data4);
    this.TempMeetingRoomTnc.push(data4);
    this.meetingRoomContacts.push(data2);
    this.TempMeetingRoomContacts.push(data2);
    this.TempMeetingRoomCanCal.push(data);
    this.meetingRoomCanCal.push(data);
    this.meetingRoomPolicy.push(data3);
    this.TempMeetingRoomPolicies.push(data3);
    this.TempRateCardHourCal.push(data5);
    this.meetingRoomType = localStorage.getItem('meetingRoomName');

    this.GetCancalUnitFordropdown();

    this.HeaderMeetingRoomName = 'Create New Meeting Room';

    this.unitTypeList.forEach((element) => {
      this.meetingRoomCanCal.push(element);
      this.TempMeetingRoomCanCal.push(element);
    });
  }

  GetCancalUnitFordropdown() {
    this.apiSrvice.getCanCalunit().subscribe((res) => {
      this.unitTypeList = res;
      console.log(this.unitTypeList);
      if (this.meetingRoomId == null) {
        console.log(this.unitTypeList);
        this.setUnitType(this.unitTypeList[0], 0);
      }
    });
  }

  getMeetingRoomDetails(meetingRoomId) {
    this.securityDepositVal = false;
    this.meetingRoomCapaciltyVal = false;
    this.bookingCapaciltyVal = false;
    this.minBookingDurationVal = false;
    this.selectedAminity = [];
    this.minAutoCancelDurationVal = false;
    this.maxBookingDurationVal = false;

    const body = {
      meetingRoomId: meetingRoomId,
    };

    this.meetingService.getMeetingRoomDetails(meetingRoomId).subscribe((res) => {

      this.MeetingRoomDetails = res;
      if (this.MeetingRoomDetails != null) {
        console.log(this.MeetingRoomDetails.taxZoneType);
        this.getGSTDetail(this.MeetingRoomDetails.taxZoneType);

        let tempStrtTime = new Date(this.MeetingRoomDetails.operationStartTime);
        let tempEndTime = new Date(this.MeetingRoomDetails.operationEndTime);

        this.startTime = {
          hour: tempStrtTime.getHours(),
          minute: tempStrtTime.getMinutes(),
        };
        this.endTime = {
          hour: tempEndTime.getHours(),
          minute: tempEndTime.getMinutes(),
        };
        console.log(this.startTime);
        console.log(this.endTime);

        if (this.MeetingRoomDetails?.isAllDaysOperation === true) {
          this.fromDaysOperation = '';
          this.toDaysOperation = '';
        } else {
          this.fromDaysOperation = this.MeetingRoomDetails.fromDayOperation ? this.MeetingRoomDetails.fromDayOperation.toString() : '';
          // this.toDaysOperation = this.MeetingRoomDetails.toDayOperation ? this.MeetingRoomDetails.toDayOperation.toString() : '';
          this.toDaysOperation = this.MeetingRoomDetails.toDayOperation;
        }

        this.companyTenantAdminId = this.MeetingRoomDetails?.companyTenantId ? this.MeetingRoomDetails?.companyTenantId : '';

        this.onTimeChange(this.startTime);
        this.onTimeChange1(this.endTime);

        let mStartDate = new Date(this.MeetingRoomDetails?.operationStartTime);
        let mEndDate = new Date(this.MeetingRoomDetails?.operationEndTime);
        let fstartTime = new Date(this.MeetingRoomDetails.operationStartTime);
        let fendTime = new Date(this.MeetingRoomDetails.operationEndTime);
        this.meetingRoomTypeId = this.MeetingRoomDetails.meetingRoomTypeId;
        (this.roomName = this.MeetingRoomDetails.roomName),
          (this.meetingRoomType = this.MeetingRoomDetails.meetingRoomType),
          (this.description = this.MeetingRoomDetails.description),
          (this.ParkId = this.MeetingRoomDetails.parkId),
          (this.formatDate = this.dateSrv.convertDateToLocaleString(
            mStartDate.getDate(),
            mStartDate.getMonth(),
            mStartDate.getFullYear()
          ));
        this.formatToDate = this.dateSrv.convertDateToLocaleString(
          mEndDate.getDate(),
          mEndDate.getMonth(),
          mEndDate.getFullYear()
        );

        this.updateSelectedDate(new NgbDate(mStartDate.getFullYear(), mStartDate.getMonth() + 1, mStartDate.getDate()));
        this.updateSelectedToDate(new NgbDate(mEndDate.getFullYear(), mEndDate.getMonth() + 1, mEndDate.getDate()));

        // Start new maintenance calandar
        if (this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail.length > 0) {

          this.selectedDateMainten = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].maintananceStarDateTime ? this.formatDateAll(this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].maintananceStarDateTime) : '';
          this.selectedToDateMainten = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].maintananceEndDateTime ? this.formatDateAll(this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].maintananceEndDateTime) : '';
          this.selectFromDateMt = this.formatDateToDateString(this.selectedDateMainten);
          this.selectToDateMt = this.formatDateToDateString(this.selectedToDateMainten);
          this.startDateOfMaintenance = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].maintananceStarDateTime ? this.getDateinNgbFormat(this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].maintananceStarDateTime) : '';
          this.endDateOfMaintenance = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].maintananceEndDateTime ? this.getDateinNgbFormat(this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].maintananceEndDateTime) : '';

          this.repeatEveryType = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].repeatModeEveryCount ? this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].repeatModeEveryCount : 1;
          this.repeatEvery = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].repeatMode ? this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].repeatMode : '0';
          this.isAllDay = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].isAllDay ? this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].isAllDay : false;
          if (this.isAllDay === true) {
            this.timeFieldDisabled = true;

            this.startTimePlaceholderMaint = this.startTimePlaceholder; // "07:00 AM";
            this.endTimePlaceholderMaint = this.endTimePlaceholder; // "07:00 PM";
            this.amorpm4 = false;
            this.amorpm5 = true;

            this.startTimeMaintenance = this.convertTimeToHourMinute(this.startTimePlaceholder); // { hour: 7, minute: 0 };
            this.endTimeMaintenance = this.convertTimeToHourMinute(this.endTimePlaceholder); // { hour: 7, minute: 0 };
          } else {
            this.timeFieldDisabled = false;

            this.startTimePlaceholderMaint = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].startTime ? this.convertTo12HourFormat(this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].startTime) : '';
            this.endTimePlaceholderMaint = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].endTime ? this.convertTo12HourFormat(this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].endTime) : '';
            this.startTimeMaintenance = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].startTime ? this.convertToHourMinuteObject(this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].startTime) : { hour: 7, minute: 0 };
            this.endTimeMaintenance = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].endTime ? this.convertToHourMinuteObject(this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].endTime) : { hour: 7, minute: 0 };
          }
          this.monthDateValueModel = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].repeatOnDay ? this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].repeatOnDay : '1';
          this.monthlyRepeateOnWeekName = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].weekDay ? this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].weekDay : '1';
          this.monthlyRepeateOnWeekStarting = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].weekNumber ? this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].weekNumber : '0';
          this.monthsOfOperationModel = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].repeatMonth ? this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].repeatMonth : '0';

          if (this.repeatEvery == '0') {
            this.repeatEveryText = 'Day(s)';
            this.selectedDaily = true;
            this.minRepeat = 1;
            this.maxRepeat = 31;
            this.weekNameArray = [];
          } else if (this.repeatEvery == '1') {
            this.repeatEveryText = 'Week(s)';
            this.selectedWeekly = true;
            this.minRepeat = 1;
            this.maxRepeat = 4;
          } else if (this.repeatEvery == '2') {
            this.repeatEveryText = 'Month(s)';
            this.selectedMonthly = true;
            this.minRepeat = 1;
            this.maxRepeat = 12;
            this.weekNameArray = [];
          } else if (this.repeatEvery == '3') {
            this.repeatEveryText = 'Year(s)';
            this.selectedYearly = true;
            this.minRepeat = 1;
            this.maxRepeat = 99;
            this.weekNameArray = [];
          } else {
            this.repeatEveryText = 'Day(s)';
            this.selectedDaily = true;
            this.minRepeat = 1;
            this.maxRepeat = 31;
            this.weekNameArray = [];
          }

          if (this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].repeatWeeksOn != '') {
            const array = this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].repeatWeeksOn.split(',');
            this.weeksOfOperation.forEach(day => {
              // Check if the id exists in providedArray
              if (array.includes(day.id)) {
                // If yes, set selected to true
                day.selected = true;
                this.weekNameArray.push(day.id);
              } else {
                // If no, set selected to false
                day.selected = false;
              }
            });
          }

          if (this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail[0].isRepeatOnDay === true) {
            this.monthlyRepeateOnModel = '1';
            // this.monthlyRepeateOnWeekName = '1'; // select day
            // this.monthlyRepeateOnWeekStarting = '0'; //select every
          } else {
            this.monthlyRepeateOnModel = '2';
            this.monthDateValueModel = '1';
          }
        } else {
          this.selectedDateMainten = ''; // this.MeetingRoomDetails.maintainenceStartDate ? this.formatDateAll(this.MeetingRoomDetails.maintainenceStartDate) : '';
          this.selectedToDateMainten = ''; // this.MeetingRoomDetails.maintainenceEndDate ? this.formatDateAll(this.MeetingRoomDetails.maintainenceEndDate) : '';
          this.selectFromDateMt = this.MeetingRoomDetails.maintainenceStartDate ? this.formatDateToDateString(this.selectedDateMainten) : '';
          this.selectToDateMt = this.MeetingRoomDetails.maintainenceEndDate ? this.formatDateToDateString(this.selectedToDateMainten) : '';
          this.startDateOfMaintenance = ''; // this.MeetingRoomDetails.maintainenceStartDate ? this.getDateinNgbFormat(this.MeetingRoomDetails.maintainenceStartDate) : '';
          this.endDateOfMaintenance = ''; // this.MeetingRoomDetails.maintainenceEndDate ? this.getDateinNgbFormat(this.MeetingRoomDetails.maintainenceEndDate) : '';
        }
        // End new maintenance calandar

        // this.securityDeposit = this.MeetingRoomDetails.securityDeposit == 0 || this.MeetingRoomDetails.securityDeposit == null || this.MeetingRoomDetails.securityDeposit == '' ? null : this.MeetingRoomDetails.securityDeposit; //sending null value
        this.securityDeposit =
          this.MeetingRoomDetails.securityDeposit == 0 ||
            this.MeetingRoomDetails.securityDeposit == null ||
            this.MeetingRoomDetails.securityDeposit == ''
            ? 0
            : this.MeetingRoomDetails.securityDeposit; //sending 0 value
        if (this.securityDeposit != null) {
          this.showSecurity = true;
          this.securityDepositVal = true;
        }
        if (this.MeetingRoomDetails?.meetingRoomCapacilty !== null) {
          this.meetingRoomCapaciltyVal = true;
        }
        if (this.MeetingRoomDetails?.capacity !== null) {
          this.bookingCapaciltyVal = true;
        }
        if (this.MeetingRoomDetails?.minBookingDuration !== null) {
          this.minBookingDurationVal = true;
        }
        if (this.MeetingRoomDetails?.maxBookingDuration !== null) {
          this.maxBookingDurationVal = true;
        }
        if (this.MeetingRoomDetails?.minAutoCancelDuration !== null) {
          this.minAutoCancelDurationVal = true;
        }

        this.capacity =
          this.MeetingRoomDetails.capacity == 0 ||
            this.MeetingRoomDetails.capacity == null ||
            this.MeetingRoomDetails.capacity == ''
            ? 1
            : this.MeetingRoomDetails.capacity;

        this.meetingRoomCapacilty =
          this.MeetingRoomDetails.meetingRoomCapacilty == 0 ||
            this.MeetingRoomDetails.meetingRoomCapacilty == null ||
            this.MeetingRoomDetails.meetingRoomCapacilty == ''
            ? 1
            : this.MeetingRoomDetails.meetingRoomCapacilty;

        this.minbookingDuration =
          this.MeetingRoomDetails.minBookingDuration == 0 ||
            this.MeetingRoomDetails.minBookingDuration == null ||
            this.MeetingRoomDetails.minBookingDuration == ''
            ? 0.5
            : this.MeetingRoomDetails.minBookingDuration;

        this.maxbookingDuration =
          this.MeetingRoomDetails.maxBookingDuration == 0 ||
            this.MeetingRoomDetails.maxBookingDuration == null ||
            this.MeetingRoomDetails.maxBookingDuration == ''
            ? 0.5
            : this.MeetingRoomDetails.maxBookingDuration;

        this.minAutoCancelDuration =
          this.MeetingRoomDetails.minAutoCancelDuration == 0 ||
            this.MeetingRoomDetails.minAutoCancelDuration == null ||
            this.MeetingRoomDetails.minAutoCancelDuration == ''
            ? 15
            : this.MeetingRoomDetails.minAutoCancelDuration;

        if (this.meetingRoomCapaciltyVal == true) {
          this.showMeetingRoom = true;
        }
        if (this.bookingCapaciltyVal == true) {
          this.showBooking = true;
        }
        //toggleBooking()

        (this.hourRate = this.MeetingRoomDetails.rateHourly),
          (this.hourAdditional = this.MeetingRoomDetails.additonalHourRate),
          (this.dailyRate = this.MeetingRoomDetails.dailyRate),
          (this.dailyAdditional = this.MeetingRoomDetails.additionalDayRate),
          (this.startTime = {
            hour: fstartTime.getHours(),
            minute: fstartTime.getMinutes(),
          }),
          (this.endTime = {
            hour: fendTime.getHours(),
            minute: fendTime.getMinutes(),
          });

        this.onTimeChange(this.startTime);
        this.onTimeChange1(this.endTime);

        console.log(this.endTime);
        console.log(this.MeetingRoomDetails.parkMeetingRoomTimeSlabList.length);
        if (this.MeetingRoomDetails.parkMeetingRoomTimeSlabList.length > 0) {

          let arrayLength = this.MeetingRoomDetails.parkMeetingRoomTimeSlabList.length - 1;
          this.finalDailyStartTime = this.MeetingRoomDetails.parkMeetingRoomTimeSlabList[0].fromTime;
          this.finalDailyEndTime = this.MeetingRoomDetails.parkMeetingRoomTimeSlabList[arrayLength].toTime;

          for (let h = 0; h < this.MeetingRoomDetails.parkMeetingRoomTimeSlabList.length; h++) {
            const tempTimeSlabRateDetails = {
              isActive: true,
              roomTimeSlabId: this.MeetingRoomDetails.parkMeetingRoomTimeSlabList[h].roomTimeSlabId
                ? this.MeetingRoomDetails.parkMeetingRoomTimeSlabList[h].roomTimeSlabId
                : null,
              hourRate: this.MeetingRoomDetails.parkMeetingRoomTimeSlabList[h].rateHourly
                ? this.MeetingRoomDetails.parkMeetingRoomTimeSlabList[h].rateHourly
                : 0,
              stimerate: this.MeetingRoomDetails.parkMeetingRoomTimeSlabList[h].fromTime
                ? this.MeetingRoomDetails.parkMeetingRoomTimeSlabList[h].fromTime
                : null,
              etimerate: this.MeetingRoomDetails.parkMeetingRoomTimeSlabList[h].toTime
                ? this.MeetingRoomDetails.parkMeetingRoomTimeSlabList[h].toTime
                : null,
              // createdBy: 1,
              // modifiedBy: 1,
              // meetingRoomId: this.meetingRoomId,
              // isDelete: !this.TempRateCardHourCal[j].isActive ? true : false,
            };
            this.TempRateCardHourCal.push(tempTimeSlabRateDetails);
          }
        } else {
          const data5 = {
            parkMeetingRoomTimeSlabListId: null,
            isActive: true,
            hourRate: 0,
            stimerate: null,
            etimerate: null,
          };
          this.TempRateCardHourCal.push(data5);
        }

        this.parkMeetingRoomAmenities = this.MeetingRoomDetails.meetingAmenityResponseList.map(id => ({
          "AmenitiesId": id.amenitiesId
        }));

        this.MeetingRoomDetails.parkMeetingRoomPoliciesList.forEach((element) => {
          this.meetingRoomPolicy.push(element);
          this.TempMeetingRoomPolicies.push(element);
        });

        this.MeetingRoomDetails.parkMeetingRoomTermsList.forEach((element) => {
          this.meetingRoomTnc.push(element);
          this.TempMeetingRoomTnc.push(element);
        });

        this.MeetingRoomDetails.parkMeetingRoomContactList.forEach((element) => {
          this.meetingRoomContacts.push(element);
          this.TempMeetingRoomContacts.push(element);
        });

        this.MeetingRoomDetails.parkMeetingRoomImagesList.forEach((element) => {
          // this.meetingRoomImages.push(element);
          // this.TempMeetingRoomImages.push(element);
          this.meetingRoomImages.push({ ...element, isActive: element?.isActive !== false });
          this.TempMeetingRoomImages.push({ ...element, isActive: element?.isActive !== false });
        });
        this.MeetingRoomDetails.parkMeetingRoomCancellationCalcsList.forEach(
          (element) => {
            this.meetingRoomCanCal.push(element);
            this.TempMeetingRoomCanCal.push(element);
          }
        );

        this.MeetingRoomDetails?.meetingAmenityResponseList.forEach((element) => {
          this.selectedAminity.push(element.amenitiesId);
        });
        console.log(this.selectedAminity);

        let arrayLength = this.MeetingRoomDetails?.parkMeetingRoomTimeSlabList.length - 1;
        if (this.MeetingRoomDetails?.parkMeetingRoomTimeSlabList[arrayLength].toTime == null && this.MeetingRoomDetails?.parkMeetingRoomTimeSlabList[arrayLength].fromTime == null) {
          this.stimeratePlaceHolder = false;
          this.etimeratePlaceHolder = false;
        }
      }
    });
  }

  concatDateTime(type) {
    console.log(this.endTimePlaceholder);
    console.log(this.startTimePlaceholder);

    let arrayLength = this.timeSlabRate.length - 1;
    if (this.timeSlabRate[arrayLength].toTime == null && this.timeSlabRate[arrayLength].fromTime == null) {
      this.startTimePlaceholder = '12:00 AM';
      this.endTimePlaceholder = '11:59 PM';
    }

    const jsDate = new Date();
    this.todayDate = this.datepipe.transform(jsDate, 'MM-dd-yyyy');

    const jsDatenext = new Date(); // Your original date
    const nextDate = new Date(jsDatenext);
    nextDate.setDate(jsDatenext.getDate() + 1); // Add one day
    const formattedNextDate = this.datepipe.transform(nextDate, 'MM-dd-yyyy');

    this.nextDate = formattedNextDate;
    if (type == 'mstart') {
      return (this.mdate = this.todayDate.concat(
        ' ' + this.startTimePlaceholder
      ));
    } else {
      return (this.mend = this.todayDate.concat(' ' + this.endTimePlaceholder));
    }
  }

  validate(val) {
    this.inValidText = '';

    this.showError = false;
    this.errSecurity = false;
    this.errName = false;
    this.errDes = false;
    this.errorText = '';
    this.errFromDayOperation = false;
    this.errToDayOperation = false;
    this.errstartDateOfMaintenance = false;
    this.errendDateOfMaintenance = false;
    this.errOperationHours = false;

    if (val.form.controls.fName?.status == 'INVALID') this.errName = true;
    if (val.form.controls.desc?.status == 'INVALID') this.errDes = true;

    console.log(val.form.controls.FOperation?.status);
    if (val.form.controls.FOperation?.status == 'INVALID') this.errFromDayOperation = true;
    if (val.form.controls.TOperation?.status == 'INVALID') this.errToDayOperation = true;

    if (this.showSecurity == true && this.spaceOnRent == false) {
      if (val.form.controls.securityAmt?.status == 'INVALID')
        this.errSecurity = true;
    }

    if (this.spaceOnRent == false) {
      this.TempMeetingRoomTnc.forEach((res, i) => {
        console.log(res);
        if (this.xssValidation.containsScriptTag(res.termDescription)) {
          this.inValidText = '* Invalid Text';
        }
        if (res.termDescription == undefined || res.termDescription.length == 0) {
          this.error[res.termDescription + i] = true;
          this.errorText = '*All fields are mandatory';
        }
      });

      // this.meetingRoomPolicy.forEach((res, i) => {
      //   if (
      //     reOpen.exec(res.policyDescription) ||
      //     reClose.exec(res.policyDescription)
      //   ) {
      //     this.inValidText = '* Invalid Text';
      //   }
      // });

      // this.TempMeetingRoomCanCal.forEach((res, i) => {
      //   console.log(res);
      //   if (res.timePrior == undefined || res.timePrior.length == 0) {
      //     this.error[res.timePrior + i] = true;
      //     this.errorText = '*All fields are mandatory';
      //   }
      //   if (res.amountDeducted == undefined || res.amountDeducted.length == 0) {
      //     this.error[res.amountDeducted + i] = true;
      //     this.errorText = '*All fields are mandatory';
      //   }
      // });

      console.log(this.TempRateCardHourCal);
    }

    this.TempMeetingRoomContacts.forEach((res, i) => {
      console.log(res);
      if (
        res.contactNumber == undefined ||
        res.contactNumber.length == 0 ||
        !/^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/.test(
          res.contactNumber
        )
      ) {
        console.log('ds', i);
        // this.error[res.contactNumber + i] = true;
        // this.errorText = '*All fields are mandatory';
      }
      if (
        res.contactEmail == undefined ||
        res.contactEmail.length == 0 ||
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(res.contactEmail)
      ) {
        console.log('ds', i);
        // this.error[res.contactEmail + i] = true;
        // this.errorText = '*All fields are mandatory';
      }
    });

    if (this.xssValidation.containsScriptTag(this.roomName)) {
      this.inValidText = '* Invalid Text';
    }
    if (this.xssValidation.containsScriptTag(this.description)) {
      this.inValidText = '* Invalid Text';
    }

    for (let i = 0; i < this.TempRateCardHourCal.length; i++) {
      const start = this.TempRateCardHourCal[i].stimerate;
      const end = this.TempRateCardHourCal[i].etimerate;
      if (start && !end) {
        this.errOperationHours = true;
        this.appStateSrv.showToast('End Time is mandatory when Start Time is provided.');
        break;
      } else if (!start && end) {
        this.errOperationHours = true;
        this.appStateSrv.showToast('Start Time is mandatory when End Time is provided.');
        break;
      }
    }

    if (
      this.errSecurity ||
      this.errName ||
      this.errDes ||
      this.errFromDayOperation ||
      this.errToDayOperation ||
      this.errstartDateOfMaintenance ||
      this.errendDateOfMaintenance ||
      this.errOperationHours ||
      this.inValidText !== ''
    ) {
      this.showError = true;
      return;
    }
  }

  // Function to get error message based on error key
  getErrorMessage(errorKey: string, errorValue: any) {
    switch (errorKey) {
      case 'required':
        return 'This field is required.';
      case 'pattern':
        return 'Invalid format.';
      // Add more cases as needed for other error types
      default:
        return `Invalid value: ${errorValue}`;
    }
  }

  save(event: Event, val: NgForm) {
    if (event && event.preventDefault) event.preventDefault();
    if (event && event.stopPropagation) event.stopPropagation();

    this.validate(val);

    console.log(val.valid);

    let requiredFieldsValid = true;
    for (const controlName in val.controls) {
      if (val.controls.hasOwnProperty(controlName)) {
        const control = val.controls[controlName];
        // Check only the required fields
        if (control.errors && control.errors.required) {
          requiredFieldsValid = false;
          break; // No need to continue checking if one required field is invalid
        }
      }
    }

    if (requiredFieldsValid) {
      // Proceed with form submission
      console.log("Form submitted successfully!");
    } else {
      // Handle the case where required fields are not filled
      console.error("Required fields are not filled.");
      this.scrollToFirstInvalidControl();
    }

    //maintenance calender
    this.finalMaintenaceCalArray = [];

    // if (this.startTimePlaceholder != undefined && this.endTimePlaceholder != undefined) {
    //   if (this.startTimePlaceholder == this.endTimePlaceholder) {
    //     this.appStateSrv.showToast(
    //       'Start time and end time can not be same.'
    //     );
    //     return;
    //   }

    //   const isValidDailyTime = this.isEndTimeGreaterThanStartTime(this.startTimePlaceholder, this.endTimePlaceholder);
    //   console.log(isValidDailyTime);
    //   if (isValidDailyTime === false) {
    //     this.appStateSrv.showToast(
    //       'End time cannot be less than start time.'
    //     );
    //     return;
    //   }
    // }

    if (this.startTimePlaceholderMaint != undefined && this.endTimePlaceholderMaint != undefined) {

      if (this.startTimePlaceholderMaint == this.endTimePlaceholderMaint) {
        this.appStateSrv.showToast(
          'Maintainence start time and maintainence end time can not be same.'
        );
        return;
      }

      const isValid = this.isEndTimeGreaterThanStartTime(this.startTimePlaceholderMaint, this.endTimePlaceholderMaint);
      console.log(isValid);
      if (isValid === false) {
        this.appStateSrv.showToast(
          'Maintainence end time can not be less than maintainence start time.'
        );
        return;
      }
    }

    if (this.selectedDateMainten != '' && this.selectedToDateMainten != '') {
      const selectedWeeks = Array.isArray(this.weekNameArray)
        ? this.weekNameArray.map((day) => Number(day))
        : [];
      const dataMaintenanceCalender = {
        maintenanceStartDateTime: this.formatDateAll(this.selectedDateMainten),
        maintenanceEndDateTime: this.formatDateAll(this.selectedToDateMainten),
        startTime: this.startTimePlaceholderMaint != undefined ? this.startTimePlaceholderMaint : null,
        endTime: this.endTimePlaceholderMaint != undefined ? this.endTimePlaceholderMaint : null,
        isAllDay: this.isAllDay,
        repeatMode: this.repeatEvery,
        repeatModeEveryCount: this.repeatEveryType,
        repeatWeeksOn: selectedWeeks,
        isRepeatOnDay: this.monthlyRepeateOnModel == "1" ? true : false,
        repeatOnDay: this.monthDateValueModel,
        weekNumber: this.monthlyRepeateOnModel == "2" ? this.monthlyRepeateOnWeekStarting : '0',
        weekDay: this.monthlyRepeateOnModel == "2" ? this.monthlyRepeateOnWeekName : '1',
        repeatMonth: this.monthsOfOperationModel,
        ...(this.meetingRoomId != null ? { meetingRoomId: this.meetingRoomId } : {}),
      };
      this.finalMaintenaceCalArray.push(dataMaintenanceCalender);
    }
    console.log(this.finalMaintenaceCalArray);

    if (this.showError == true) {
      return;
    }

    if (this.errorText !== '') {
      return;
    }

    console.log(this.selectFromDateMt);
    console.log(this.selectToDateMt);
    if (this.selectedYearly == true) {
      let validateYeat = this.isDifferenceMoreThanOneYear(this.selectFromDateMt, this.selectToDateMt);
      if (validateYeat === false) {
        this.appStateSrv.showToast(
          'Please select date range more than one year.'
        );
        return;
      }
    }

    if (this.roomName.length > 200) {
      this.appStateSrv.showToast(
        'Name should not be more than 200 characters.'
      );
      return;
    }

    if (this.hasWhitespaceAtStartOrEnd(this.roomName) === true) {
      this.appStateSrv.showToast('Name should not have whitespace at start or end.');
      return;
    }

    if (this.hasWhitespaceAtStartOrEnd(this.description) === true) {
      this.appStateSrv.showToast('Description should not have whitespace at start or end.');
      return;
    }

    if (this.meetingRoomImages.length == 0) {
      this.appStateSrv.showToast('Please upload image');
      return;
    }

    // if (this.spaceOnRent == false) {
    //   if (
    //     this.meetingRoomPolicy[0].policyDescription == null ||
    //     this.meetingRoomPolicy[0].policyDescription == ''
    //   ) {
    //     this.appStateSrv.showToast('Policies are mandatory');
    //     return;
    //   }
    // }

    var dateOne =
      this.selectedDate.split('/')[2] == undefined
        ? new Date(
          this.selectedDate.split('-')[0],
          this.selectedDate.split('-')[1] - 1,
          this.selectedDate.split('-')[2]
        )
        : new Date(
          this.selectedDate.split('/')[2],
          this.selectedDate.split('/')[0] - 1,
          this.selectedDate.split('/')[1]
        ); //Year, Month, Date
    var dateTwo =
      this.selectedToDate.split('/')[2] == undefined
        ? new Date(
          this.selectedToDate.split('-')[0],
          this.selectedToDate.split('-')[1] - 1,
          this.selectedToDate.split('-')[2]
        )
        : new Date(
          this.selectedToDate.split('/')[2],
          this.selectedToDate.split('/')[0] - 1,
          this.selectedToDate.split('/')[1]
        ); //Year, Month, Date

    if (dateOne > dateTwo) {
      return this.appStateSrv.showToast(
        'From date should not be greater than to date'
      );
    }

    var dateThree = this.selectedDateMainten.split('/')[2] == undefined
      ? new Date(
        this.selectedDateMainten.split('-')[0],
        this.selectedDateMainten.split('-')[1] - 1,
        this.selectedDateMainten.split('-')[2]
      )
      : new Date(
        this.selectedDateMainten.split('/')[2],
        this.selectedDateMainten.split('/')[0] - 1,
        this.selectedDateMainten.split('/')[1]
      ); //Year, Month, Date
    var dateFour =
      this.selectedToDateMainten.split('/')[2] == undefined
        ? new Date(
          this.selectedToDateMainten.split('-')[0],
          this.selectedToDateMainten.split('-')[1] - 1,
          this.selectedToDateMainten.split('-')[2]
        )
        : new Date(
          this.selectedToDateMainten.split('/')[2],
          this.selectedToDateMainten.split('/')[0] - 1,
          this.selectedToDateMainten.split('/')[1]
        ); //Year, Month, Date

    if (dateThree > dateFour) {
      return this.appStateSrv.showToast(
        'Maintenance From date should not be less than maintenance to date.'
      );
    }

    //rate card checking
    this.dailyRateCardAllTimeSum = this.checkDailyMaintenanceTime();
    console.log(this.dailyRateCardAllTimeSum);
    this.rateCardAllTimeSum = 0;
    if (this.TempRateCardHourCal.length > 0) {
      console.log(this.TempRateCardHourCal);
      for (let h = 0; h < this.TempRateCardHourCal.length; h++) {
        let fromTime = this.TempRateCardHourCal[h].stimerate ? this.TempRateCardHourCal[h].stimerate : null;
        let toTime = this.TempRateCardHourCal[h].etimerate ? this.TempRateCardHourCal[h].etimerate : null;
        if (fromTime != null && toTime != null) {
          this.rateCardAllTimeSum += this.checkRateCardMaintenanceTimeSum(fromTime, toTime);

          const [hours1, minutes1, period1] = this.startTimePlaceholder.split(/:| /);
          const [hours2, minutes2, period2] = this.endTimePlaceholder.split(/:| /);

          const [hours3, minutes3, period3] = this.TempRateCardHourCal[0].stimerate.split(/:| /);
          const [hours4, minutes4, period4] = this.TempRateCardHourCal[this.TempRateCardHourCal.length - 1].etimerate.split(/:| /);

          if (((hours3 < hours1) && (period3 == period1))) {
            this.appStateSrv.showToast('Slot start time does not match with room start time.');
            return;
          }

          if (((hours4 > hours2) && (period4 == period2))) {
            this.appStateSrv.showToast('Slot end time does not match with room end time.');
            return;
          }
          if (hours4 != 12 && period4 != 'PM') {
            if (((hours4 > hours2) && (period4 == period2))) {
              this.appStateSrv.showToast('Slot end time does not match with room end time.');
              return;
            }
          }
        }
        let checkOveelappedData = this.checkForOverlap(this.TempRateCardHourCal);
        console.log(checkOveelappedData);
        if (checkOveelappedData === true) {
          this.appStateSrv.showToast('Sorry, you can not select overlapping slot.');
          return;
        }
      }
    }

    // let timeslabhours = this.checkHourlyRateTime();

    // if (parseInt(this.dailyRateCardAllTimeSum) != parseInt(this.rateCardAllTimeSum)) {
    //   this.appStateSrv.showToast('Please enter the Start and End time for booking.');
    //   return;
    // }
    //end of rate card checking

    this.timeSlabRate = [];
    for (let h = 0; h < this.TempRateCardHourCal.length; h++) {
      const tempTimeSlabRate = {
        isActive: true,
        // parkMeetingRoomTimeSlabListId: this.TempRateCardHourCal[h].parkMeetingRoomTimeSlabListId
        //   ? this.TempRateCardHourCal[h].parkMeetingRoomTimeSlabListId
        //   : null,
        fromTime: this.TempRateCardHourCal[h].stimerate
          ? this.TempRateCardHourCal[h].stimerate
          : null,
        toTime: this.TempRateCardHourCal[h].etimerate
          ? this.TempRateCardHourCal[h].etimerate
          : null,
        rateHourly: this.TempRateCardHourCal[h].hourRate
          ? this.TempRateCardHourCal[h].hourRate
          : 0,
        ...(this.meetingRoomId != null ? { meetingRoomId: this.meetingRoomId } : {}),
      };
      this.timeSlabRate.push(tempTimeSlabRate);
    }

    this.policies = [];
    for (let j = 0; j < this.meetingRoomPolicy.length; j++) {
      const tempPolicy = {
        isActive: true,
        meetingRoomPolicyId: this.meetingRoomPolicy[j].meetingRoomPolicyId
          ? this.meetingRoomPolicy[j].meetingRoomPolicyId
          : null,
        policyDescription: this.meetingRoomPolicy[j].policyDescription
          ? this.meetingRoomPolicy[j].policyDescription
          : '',
        createdBy: 1,
        modifiedBy: 1,
        ...(this.meetingRoomId != null ? { meetingRoomId: this.meetingRoomId } : {}),
        isDelete: !this.meetingRoomPolicy[j].isActive ? true : false,
      };
      this.policies.push(tempPolicy);
    }
    this.contacts = [];
    for (let j = 0; j < this.meetingRoomContacts.length; j++) {
      const tempContacts = {
        isActive: true,

        meetingRoomContactId: this.meetingRoomContacts[j].meetingRoomContactId
          ? this.meetingRoomContacts[j].meetingRoomContactId
          : null,
        contactNumber: this.meetingRoomContacts[j].contactNumber
          ? this.meetingRoomContacts[j].contactNumber
          : null,
        contactEmail: this.meetingRoomContacts[j].contactEmail
          ? this.meetingRoomContacts[j].contactEmail
          : null,
        ...(this.meetingRoomId != null ? { meetingRoomId: this.meetingRoomId } : {}),
        createdBy: 1,
        modifiedBy: 1,
        isDelete: !this.meetingRoomContacts[j].isActive ? true : false,
      };
      this.contacts.push(tempContacts);
      this.contacts = this.contacts.filter(item => !((item.contactEmail === "" || item.contactEmail == null) && (item.contactNumber === "" || item.contactNumber == null)));
    }

    this.images = [];

    this.images = [];
    for (let j = 0; j < this.meetingRoomImages.length; j++) {
      const item = this.meetingRoomImages[j];
      const urlForMeta = !item.imgFile && item.imageURL && typeof item.imageURL === 'string' && (item.imageURL.startsWith('http') || item.imageURL.startsWith('https'))
        ? item.imageURL
        : null;
      const tempimages = {
        isActive: item.isActive,
        imageId: item.imageId ? item.imageId : null,
        imageURL: urlForMeta,
        ...(this.meetingRoomId != null ? { meetingRoomId: this.meetingRoomId } : {}),
        createdBy: 1,
        modifiedBy: 1,
        isDelete: !item.isActive ? true : false,
      };
      this.images.push(tempimages);
    }

    this.Cancal = [];
    for (let j = 0; j < this.meetingRoomCanCal.length; j++) {
      const tempCancal = {
        isActive: true,
        meetingRoomCancellationCalculationId: this.meetingRoomCanCal[j]
          .meetingRoomCancellationCalculationId
          ? this.meetingRoomCanCal[j].meetingRoomCancellationCalculationId
          : null,
        timePrior: this.meetingRoomCanCal[j].timePrior
          ? this.meetingRoomCanCal[j].timePrior.toString()
          : '0',
        amountDeducted: this.meetingRoomCanCal[j].amountDeducted
          ? this.meetingRoomCanCal[j].amountDeducted
          : 0,
        unitType: this.meetingRoomCanCal[j].unitTypeId
          ? this.meetingRoomCanCal[j].unitTypeId
          : null,
        ...(this.meetingRoomId != null ? { meetingRoomId: this.meetingRoomId } : {}),
        createdBy: 1,
        modifiedBy: 1,
        isDelete: !this.meetingRoomCanCal[j].isActive ? true : false,
      };
      this.Cancal.push(tempCancal);
    }

    this.TnC = [];
    for (let j = 0; j < this.meetingRoomTnc.length; j++) {
      const tempTnC = {
        isActive: this.meetingRoomTnc[j].isActive, // true,
        meetingRoomTncid: this.meetingRoomTnc[j].meetingRoomTncid
          ? this.meetingRoomTnc[j].meetingRoomTncid
          : null,
        termDescription: this.meetingRoomTnc[j].termDescription
          ? this.meetingRoomTnc[j].termDescription
          : null,

        ...(this.meetingRoomId != null ? { meetingRoomId: this.meetingRoomId } : {}),
        createdBy: 1,
        modifiedBy: 1,
        isDelete: !this.meetingRoomTnc[j].isActive ? true : false,
      };
      this.TnC.push(tempTnC);
    }

    if (!this.showBooking) this.capacity = null;
    if (!this.showMeetingRoom) this.meetingRoomCapacilty = null;

    if (this.spaceOnRent == false) {
      let startTimehour = Number(
        this.startTimePlaceholder.split(' ')[0].split(':')[0]
      );
      let endTimehour = Number(
        this.endTimePlaceholder.split(' ')[0].split(':')[0]
      );
      let startTimeMin = Number(
        this.startTimePlaceholder.split(' ')[0].split(':')[1]
      );
      let endTimeMin = Number(
        this.endTimePlaceholder.split(' ')[0].split(':')[1]
      );
      let startTimeAMorPM = this.startTimePlaceholder.split(' ')[1];
      let endTimeAMorPM = this.endTimePlaceholder.split(' ')[1];
      startTimehour = startTimeAMorPM == 'PM' ? startTimehour + 12 : startTimehour;
      endTimehour = endTimeAMorPM == 'PM' ? endTimehour + 12 : endTimehour;
      if (startTimehour > endTimehour) {
        // return this.appStateSrv.showToast('Please enter valid time');
      }
      if (startTimehour == endTimehour) {
        if (startTimeMin >= endTimeMin) {
          // return this.appStateSrv.showToast('Please enter valid time');
        }
      }
      this.concatDateTime('mstart');
      this.concatDateTime('mend');
    }

    if (this.repeatTypeValue == 'Weekly') {
      if (this.weekNameArray.length == 0) {
        return this.appStateSrv.showToast('Please select at least one week');
      }
    }

    let formattedDateFromMaint = '';
    let formattedDateToMaint = '';
    if (this.selectedDateMainten != '' && this.selectedToDateMainten != '') {
      const date = new Date(this.formatDateAll(this.selectedDateMainten));
      formattedDateFromMaint = this.formatDateForMaintenance(date);
      // date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/(\d{2}) (\w{3}) (\d{4})/, '$1 $2, $3');

      const dateto = new Date(this.formatDateAll(this.selectedToDateMainten));
      formattedDateToMaint = this.formatDateForMaintenance(dateto);
      // dateto.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/(\d{2}) (\w{3}) (\d{4})/, '$1 $2, $3');
    }

    let currentTime = new Date();
    if (this.TempRateCardHourCal[0].stimerate != null && this.TempRateCardHourCal[0].etimerate != null) {
      if (this.finalMaintenaceCalArray.length > 0) {

        if (this.getCurrentDate() == this.formatDateTimezone(this.finalMaintenaceCalArray[0].maintenanceStartDateTime)) {
          if (this.isStartTimeAfterCurrent(this.formatTime(this.finalMaintenaceCalArray[0].startTime), this.getCurrentTime(currentTime)) === false) {
            this.appStateSrv.showToast('Please select valid maintenance from time');
            return;
          }
        }

        if (this.getCurrentDate() == this.formatDateTimezone(this.finalMaintenaceCalArray[0].maintenanceEndDateTime)) {
          if (this.isStartTimeAfterCurrent(this.formatTime(this.finalMaintenaceCalArray[0].endTime), this.getCurrentTime(currentTime)) === false) {
            this.appStateSrv.showToast('Please select valid maintenance to time');
            return;
          }
        }
      }
    }

    // console.log(this.companyTenantAdminId);
    // if (this.companyTenantAdminId == null || this.companyTenantAdminId == undefined || this.companyTenantAdminId == '') {
    //   this.appStateSrv.showToast('Please select company tenant admin');
    //   return;
    // }

    const regex = /^[1-9]\d*$/;
    if (!regex.test(String(this.capacity))) {
      this.appStateSrv.showToast('Please enter attendees number');
      return;
    }

    if (this.fromDaysOperation == '' && this.toDaysOperation == '') {
      this.isWeekDaysOperation = true;
    } else {
      this.isWeekDaysOperation = false;
    }

    if (this.maxbookingDuration < this.minbookingDuration) {
      this.appStateSrv.showToast('Maximum booking duration can not be less than minimum booking duration');
      return;
    }

    if (!requiredFieldsValid) {
      console.error("Required fields are not filled.");
      this.scrollToFirstInvalidControl();
      return;
    }

    const formData = new FormData();
    if (this.meetingRoomId != null) {
      formData.append('parkMeetingRoomId', this.meetingRoomId);
    }
    formData.append('roomName', this.roomName != null ? this.roomName.trim() : '');
    formData.append('rateHourly', this.hourRate != null ? String(this.hourRate) : '');
    formData.append('additonalHourRate', this.hourAdditional != null ? String(this.hourAdditional) : '');
    formData.append('dailyRate', '0');
    formData.append('additionalDayRate', '0');
    formData.append('securityDeposit', this.securityDeposit != null ? String(this.securityDeposit) : '');
    formData.append('operationStartTime', this.mdate ? this.convertToISO(this.mdate) : '');
    formData.append('operationEndTime', this.mend ? this.convertToISO(this.mend) : '');
    formData.append('capacity', this.bookingCapaciltyVal ? String(this.capacity) : '1');
    formData.append('minBookingDuration', this.minbookingDuration != null ? String(this.minbookingDuration) : '');
    formData.append('maxBookingDuration', this.maxbookingDuration != null ? String(this.maxbookingDuration) : '');
    formData.append('minAutoCancelDuration', this.minAutoCancelDuration != null ? String(this.minAutoCancelDuration) : '');
    formData.append('maintainenceStartDate', '');
    formData.append('maintainenceEndDate', '');
    formData.append('parkId', this.ParkId != null ? this.ParkId : '');
    formData.append('isActive', 'true');
    formData.append('createdBy', '0');
    formData.append('createdDate', '');
    formData.append('modifiedBy', '0');
    formData.append('modifiedDate', '');
    formData.append('description', this.description != null ? this.description.trim() : '');
    formData.append('taxTypeId', '');
    formData.append('fromDayOperation', (this.fromDaysOperation == '' || this.fromDaysOperation == null) ? '' : this.fromDaysOperation);
    formData.append('toDayOperation', (this.toDaysOperation == '' || this.toDaysOperation == null) ? '' : this.toDaysOperation);
    formData.append('tenantId', this.parkTenantId != null ? this.parkTenantId : '');
    formData.append('isPaid', 'false');
    formData.append('companyTenantAdminId', '');
    formData.append('isCompletedByCLA', 'true');
    formData.append('isAllDaysOperation', String(!!this.isWeekDaysOperation));

    this.appendArrayToFormData(formData, 'parkMeetingRoomCancellationCalcsList', this.Cancal);
    this.appendArrayToFormData(formData, 'parkMeetingRoomContactList', this.contacts);
    this.appendArrayToFormData(formData, 'parkMeetingRoomPoliciesList', this.policies);
    this.appendArrayToFormData(formData, 'parkMeetingRoomTermsList', this.TnC);
    this.appendArrayToFormData(formData, 'parkMeetingRoomTimeSlabList', this.timeSlabRate);
    this.appendArrayToFormData(formData, 'parkMeetingRoomMaintenanceDetailList', this.finalMaintenaceCalArray);
    this.appendArrayToFormData(formData, 'parkMeetingRoomAmenities', this.parkMeetingRoomAmenities);

    let newImageIndex = 0;
    this.meetingRoomImages.forEach((img) => {
      if (img.imgFile && img.isActive !== false) {
        const fileName = (img.imgFile.name || '').split('?')[0];
        formData.append('parkMeetingRoomImagesList[' + newImageIndex + '].photoData', img.imgFile, img.imgFile.name);
        formData.append('parkMeetingRoomImagesList[' + newImageIndex + '].imageURL', fileName);
        formData.append('parkMeetingRoomImagesList[' + newImageIndex + '].isDelete', 'false');
        if (this.meetingRoomId != null) {
          formData.append('parkMeetingRoomImagesList[' + newImageIndex + '].meetingRoomId', this.meetingRoomId);
        }
        newImageIndex++;
      }
    });
    const oldImages = this.meetingRoomImages.filter(
      (img) => !img.imgFile && img.imageURL && typeof img.imageURL === 'string' && (img.imageURL.startsWith('http') || img.imageURL.startsWith('https'))
    );
    oldImages.forEach((img, idx) => {
      formData.append('parkMeetingRoomImagesList[' + (newImageIndex + idx) + '].imageURL', img.imageURL);
      formData.append('parkMeetingRoomImagesList[' + (newImageIndex + idx) + '].imageId', img.imageId != null ? img.imageId : '');
      formData.append('parkMeetingRoomImagesList[' + (newImageIndex + idx) + '].isDelete', (!img.isActive).toString());
    });
    if (newImageIndex === 0 && oldImages.length === 0) {
      formData.append('parkMeetingRoomImagesList[0].imageURL', '');
    }

    if (this.meetingRoomId != null) {
      this.meetingService.updateMeetingRoomFormData(formData).subscribe({
        next: (res) => {
          if (res.isValid) {
            this.router.navigate(['/company/view-meeting-room', this.parkTenantId]);
            this.MeetingRoomDetailsResultt = res;
            this.appStateSrv.showToast(res.successMsg);
            this.clearArrays();
          }
        },
        error: (err) => {
          console.error('Error updating meeting room', err);
          this.appStateSrv.showToast('Failed to update meeting room. Please try again.');
        }
      });
    } else {
      this.meetingService.AddMeetingRoomFormData(formData).subscribe({
        next: (res) => {
          this.MeetingRoomDetailsResultt = res;
          if (res.isValid == true) {
            this.router.navigate(['/company/view-meeting-room', this.parkTenantId]);
          }
        },
        error: (err) => {
          console.error('Error adding meeting room', err);
          this.appStateSrv.showToast('Failed to add meeting room. Please try again.');
        }
      });
    }
  }

  isStartTimeAfterCurrent(startTime, currentTime) {
    // Create a base date for both times (use today's date for consistency)
    const baseDate = new Date();

    // Parse the start time and current time strings
    const startDate = new Date(baseDate.toDateString() + ' ' + startTime);
    const currentDate = new Date(baseDate.toDateString() + ' ' + currentTime);

    // Compare the times
    return startDate > currentDate;
  }

  convertToISO(dateStr) {
    const [date, time, period] = dateStr.split(' ');
    let [month, day, year] = date.split('-');
    let [hours, minutes] = time.split(':');

    // Convert to 24-hour format if necessary
    if (period === 'PM' && hours !== '12') {
      hours = parseInt(hours, 10) + 12;
    } else if (period === 'AM' && hours === '12') {
      hours = '00';
    }

    // Ensure hours are two digits
    hours = hours.toString().padStart(2, '0');

    // Construct the ISO format string
    return `${year}-${month}-${day}T${hours}:${minutes}:00`;
  }

  updateDateToCalendar(date?: NgbDate) {
    const updatedDate =
      date == undefined
        ? this.dateAdapter.toModel(this.ngbCalendar.getToday())!
        : this.dateAdapter.toModel(date)!;
    return updatedDate;
  }

  public updateSelectedDate(date: NgbDate) {
    console.log(date);
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.selectedDate = this.convertFormat(date.year, date.month, date.day);
    this.formatDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
  }

  public updateSelectedToDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.selectedToDate = this.convertFormat(date.year, date.month, date.day);
    this.formatToDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
  }

  toggleAmPmSelection(value: boolean) {
    // console.log(value)
    this.amorpm = value;
    this.tempTime = this.startTime;
    this.onTimeChange(this.tempTime);
  }

  toggleAmPmSelection1(value: boolean) {
    this.amorpm1 = value;
    console.log('Here Prinr AMPM', this.amorpm1);
    this.tempEndTime = this.endTime;
    this.onTimeChange1(this.tempEndTime);
  }


  onTimeChangeDailyOnly(e) {
    console.log(e);
    this.tempTime = e;

    console.log(this.amorpm);
    if (this.amorpm == true && e.hour < 12) {
      this.startTime = { hour: e.hour + 12, minute: e.minute }
    }
    if (this.amorpm == true && e.hour == 0) {
      this.startTime = { hour: e.hour + 12, minute: e.minute }
    }
    if (this.amorpm == false && e.hour > 12) {
      this.startTime = { hour: e.hour - 12, minute: e.minute }
    }
    if (this.amorpm == false && e.hour == 12) {
      this.startTime = { hour: e.hour - 12, minute: e.minute }
    }
    console.log(this.amorpm);

    if (e.hour == 0) {
      this.startTimePlaceholder =
        ('0' + (e.hour == 0 ? e.hour + 12 : e.hour)).slice(-2) +
        ':' +
        ('0' + e.minute).slice(-2) +
        ' ' +
        (this.amorpm ? 'PM' : 'AM');
    } else {
      this.startTimePlaceholder =
        ('0' + (e.hour >= 12 ? e.hour - 12 : e.hour)).slice(-2) +
        ':' +
        ('0' + e.minute).slice(-2) +
        ' ' +
        (this.amorpm ? 'PM' : 'AM');
    }
  }

  onTimeChangeDailyOnly1(e) {
    console.log(e);
    this.tempEndTime = e;

    console.log(this.amorpm1);
    if (this.amorpm1 == true && e.hour < 12) {
      this.endTime = { hour: e.hour + 12, minute: e.minute }
    }
    if (this.amorpm1 == true && e.hour == 0) {
      this.endTime = { hour: e.hour + 12, minute: e.minute }
    }
    if (this.amorpm1 == false && e.hour > 12) {
      this.endTime = { hour: e.hour - 12, minute: e.minute }
    }
    if (this.amorpm1 == false && e.hour == 12) {
      this.endTime = { hour: e.hour - 12, minute: e.minute }
    }

    console.log(this.amorpm1);

    if (e.hour == 0) {
      this.endTimePlaceholder =
        ('0' + (e.hour == 0 ? e.hour + 12 : e.hour)).slice(-2) +
        ':' +
        ('0' + e.minute).slice(-2) +
        ' ' +
        (this.amorpm1 ? 'PM' : 'AM');
    } else {
      this.endTimePlaceholder =
        ('0' + (e.hour >= 12 ? e.hour - 12 : e.hour)).slice(-2) +
        ':' +
        ('0' + e.minute).slice(-2) +
        ' ' +
        (this.amorpm1 ? 'PM' : 'AM');
    }
  }


  toggleAmPmSelectionRate(value: boolean, index) {
    console.log(value)
    this.amorpm2 = value;
    this.tempTimeRate = this.startTimeRate;
    // this.onTimeChangeRateCardChangeOnly(this.tempTimeRate, index);
    this.onTimeChangeRateCard(this.tempTimeRate, index);
  }

  toggleAmPmSelectionRate1(value: boolean, index) {
    console.log(value);
    this.amorpm3 = value;
    this.tempEndTimeRate = this.endTimeRate;
    // this.onTimeChangeRateChangeOnly1(this.tempEndTimeRate, index);
    this.onTimeChangeRate1(this.tempEndTimeRate, index);
  }

  toggleMeridian() {
    this.meridian = !this.meridian;
  }


  onTimeChange(e) {
    console.log(e);
    this.tempTime = e;
    console.log(this.amorpm);

    // if (e.hour == 12 || e.hour > 12) {
    //   this.amorpm = true;
    // }
    // if (e.hour == 0 || e.hour < 12) {
    //   this.amorpm = false;
    // }

    this.startTimePlaceholder =
      ('0' + (e.hour > 12 ? e.hour - 12 : e.hour == 0 ? 12 : e.hour)).slice(-2) +
      ':' +
      ('0' + e.minute).slice(-2) +
      ' ' +
      (this.amorpm ? 'PM' : 'AM');

    let firstPlaceHolder = this.startTimePlaceholder.split(':');
    let splitedfirstPlaceHolder = firstPlaceHolder[0];
    console.log(splitedfirstPlaceHolder);
    let splitAmPm = firstPlaceHolder[1].split(' ');
    let miniutePlaceHolder = splitAmPm[0];
    console.log(miniutePlaceHolder);
    let finalAmPm = splitAmPm[1];
    console.log(finalAmPm);

    this.startTime = { hour: parseInt(splitedfirstPlaceHolder), minute: parseInt(miniutePlaceHolder) };
    if (finalAmPm == 'AM' || this.amorpm == false) {
      this.amorpm = false;
    }
    if (finalAmPm == 'PM' || this.amorpm == true) {
      this.amorpm = true;
    }


    // if (e.hour >= 12) {
    //   this.amorpm = true;
    // }
    // if (e.hour == 0 || e.hour < 12) {
    //   this.amorpm = false;
    // }

    console.log(this.amorpm);

  }

  onTimeChangeRateCard_BKP_AMPM(e, index) {
    console.log(e);
    // console.log(this.TempRateCardHourCal);
    this.tempTimeRate = e;

    if (e.hour == 12 || e.hour > 12) {
      this.amorpm2 = true;
    }
    if (e.hour == 0 || e.hour < 12) {
      this.amorpm2 = false;
    }

    this.startTimePlaceholderRate =
      ('0' + (e.hour > 12 ? e.hour - 12 : e.hour)).slice(-2) +
      ':' +
      ('0' + e.minute).slice(-2) +
      ' ' +
      (e.hour > 12 || this.amorpm2 ? 'PM' : 'AM');
    this.TempRateCardHourCal.forEach((res, i) => {
      console.log(res);
      console.log(index);
      this.TempRateCardHourCal[index].stimerate = this.startTimePlaceholderRate;
    });
    // if (e.hour >= 12 || this.amorpm) {
    //   this.amorpm2 = true;
    // } else {
    //   this.amorpm2 = false;
    // }
    if (e.hour >= 12) {
      this.amorpm2 = true;
    }
    if (e.hour == 0 || e.hour < 12) {
      this.amorpm2 = false;
    }
  }

  allDayCheckTimeHourStart(finalAmPm) {
    if (this.isAllDay) {
      this.timeFieldDisabled = true;
      this.startTimePlaceholderMaint = this.startTimePlaceholder; // "07:00 AM";
      this.amorpm4 = finalAmPm;
      this.startTimeMaintenance = this.convertTimeToHourMinute(this.startTimePlaceholder); // { hour: 7, minute: 0 };
      this.timeFieldDisabled = false;
    }
  }

  allDayCheckTimeHourEnd(finalAmPm1) {
    if (this.isAllDay) {
      this.timeFieldDisabled = true;
      this.endTimePlaceholderMaint = this.endTimePlaceholder; // "07:00 PM";
      this.amorpm5 = finalAmPm1;
      this.endTimeMaintenance = this.convertTimeToHourMinute(this.endTimePlaceholder); // { hour: 7, minute: 0 };
    } else {
      this.timeFieldDisabled = false;
    }
  }

  allDayCheckTimeHour(finalAmPm, finalAmPm1) {
    if (this.isAllDay) {
      this.timeFieldDisabled = true;

      this.startTimePlaceholderMaint = this.startTimePlaceholder; // "07:00 AM";
      this.endTimePlaceholderMaint = this.endTimePlaceholder; // "07:00 PM";
      this.amorpm4 = finalAmPm;
      this.amorpm5 = finalAmPm1;

      this.startTimeMaintenance = this.convertTimeToHourMinute(this.startTimePlaceholder); // { hour: 7, minute: 0 };
      this.endTimeMaintenance = this.convertTimeToHourMinute(this.endTimePlaceholder); // { hour: 7, minute: 0 };
    } else {
      this.timeFieldDisabled = false;
    }
  }

  checkHourTimeWithDay() {
    console.log(this.TempRateCardHourCal);
    let arrayLength = this.TempRateCardHourCal.length - 1;

    this.finalDailyStartTime = this.TempRateCardHourCal[0].stimerate;
    this.finalDailyEndTime = this.TempRateCardHourCal[arrayLength].etimerate;

    let firstPlaceHolder = this.TempRateCardHourCal[0].stimerate.split(':');
    let splitedfirstPlaceHolder = firstPlaceHolder[0];
    let splitAmPm = firstPlaceHolder[1].split(' ');
    let miniutePlaceHolder = splitAmPm[0];
    let finalAmPm = splitAmPm[1];

    let firstTme = { hour: parseInt(splitedfirstPlaceHolder), minute: parseInt(miniutePlaceHolder) };
    this.startTimePlaceholder = this.TempRateCardHourCal[0].stimerate;
    this.startTime = firstTme;

    let firstPlaceHolder1 = this.TempRateCardHourCal[arrayLength].etimerate.split(':');
    let splitedfirstPlaceHolder1 = firstPlaceHolder1[0];
    let splitAmPm1 = firstPlaceHolder1[1].split(' ');
    let miniutePlaceHolder1 = splitAmPm1[0];
    let finalAmPm1 = splitAmPm1[1];

    let endTme = { hour: parseInt(splitedfirstPlaceHolder1), minute: parseInt(miniutePlaceHolder1) };
    this.endTimePlaceholder = this.TempRateCardHourCal[arrayLength].etimerate;
    this.endTime = endTme;

    this.allDayCheckTimeHour(finalAmPm, finalAmPm1);
  }

  onTimeChangeRateCard(e, index) {
    console.log(e);
    // console.log(this.TempRateCardHourCal);
    this.tempTimeRate = e;

    this.startTimePlaceholderRate =
      ('0' + (e.hour > 12 ? e.hour - 12 : e.hour == 0 ? 12 : e.hour)).slice(-2) +
      ':' +
      ('0' + e.minute).slice(-2) +
      ' ' +
      (this.amorpm2 ? 'PM' : 'AM');
    this.TempRateCardHourCal.forEach((res, i) => {
      console.log(res);
      console.log(i);
      this.TempRateCardHourCal[index].stimerate = this.startTimePlaceholderRate;
    });

    let firstPlaceHolder = this.startTimePlaceholderRate.split(':');
    let splitedfirstPlaceHolder = firstPlaceHolder[0];
    console.log(splitedfirstPlaceHolder);
    let splitAmPm = firstPlaceHolder[1].split(' ');
    let miniutePlaceHolder = splitAmPm[0];
    console.log(miniutePlaceHolder);
    let finalAmPm = splitAmPm[1];
    console.log(finalAmPm);

    this.startTimeRate = { hour: parseInt(splitedfirstPlaceHolder), minute: parseInt(miniutePlaceHolder) };

    this.startTimePlaceholder = this.startTimePlaceholderRate;
    this.startTime = this.startTimeRate;
    // this.allDayCheckTimeHour();

    if (finalAmPm == 'AM' || this.amorpm2 == false) {
      this.amorpm2 = false;
    }
    if (finalAmPm == 'PM' || this.amorpm2 == true) {
      this.amorpm2 = true;
    }
    this.allDayCheckTimeHourStart(this.amorpm2);
  }

  onTimeChangeRateCardChangeOnly(e, index) {
    console.log(e);
    this.tempTimeRate = e;

    console.log(this.amorpm2);
    if (this.amorpm2 == true && e.hour < 12) {
      this.startTimeRate = { hour: e.hour + 12, minute: e.minute }
    }
    if (this.amorpm2 == true && e.hour == 0) {
      this.startTimeRate = { hour: e.hour + 12, minute: e.minute }
    }
    if (this.amorpm2 == false && e.hour > 12) {
      this.startTimeRate = { hour: e.hour - 12, minute: e.minute }
    }
    if (this.amorpm2 == false && e.hour == 12) {
      this.startTimeRate = { hour: e.hour - 12, minute: e.minute }
    }

    console.log(this.amorpm2);

    if (e.hour == 0) {
      this.startTimePlaceholderRate =
        ('0' + (e.hour == 0 ? e.hour + 12 : e.hour)).slice(-2) +
        ':' +
        ('0' + e.minute).slice(-2) +
        ' ' +
        (this.amorpm2 ? 'PM' : 'AM');
    } else {
      this.startTimePlaceholderRate =
        ('0' + (e.hour >= 12 ? e.hour - 12 : e.hour)).slice(-2) +
        ':' +
        ('0' + e.minute).slice(-2) +
        ' ' +
        (this.amorpm2 ? 'PM' : 'AM');
    }
    this.TempRateCardHourCal.forEach((res, i) => {
      console.log(res);
      console.log(index);
      this.TempRateCardHourCal[index].stimerate = this.startTimePlaceholderRate;
    });
  }

  onTimeChange1(e) {
    console.log(e);
    this.tempEndTime = e;
    console.log(this.amorpm1);

    // if (e.hour == 12 || e.hour > 12) {
    //   this.amorpm1 = true;
    // }
    // if (e.hour == 0 || e.hour < 12) {
    //   this.amorpm1 = false;
    // }

    this.endTimePlaceholder =
      ('0' + (e.hour > 12 ? e.hour - 12 : e.hour == 0 ? 12 : e.hour)).slice(-2) +
      ':' +
      ('0' + e.minute).slice(-2) +
      ' ' +
      (this.amorpm1 ? 'PM' : 'AM');

    // if (e.hour >= 12) {
    //   this.amorpm1 = true;
    // }
    // if (e.hour == 0 || e.hour < 12) {
    //   this.amorpm1 = false;
    // }

    let firstPlaceHolder = this.endTimePlaceholder.split(':');
    let splitedfirstPlaceHolder = firstPlaceHolder[0];
    console.log(splitedfirstPlaceHolder);
    let splitAmPm = firstPlaceHolder[1].split(' ');
    let miniutePlaceHolder = splitAmPm[0];
    console.log(miniutePlaceHolder);
    let finalAmPm = splitAmPm[1];
    console.log(finalAmPm);

    this.endTime = { hour: parseInt(splitedfirstPlaceHolder), minute: parseInt(miniutePlaceHolder) };
    if (finalAmPm == 'AM' || this.amorpm1 == false) {
      this.amorpm1 = false;
    }
    if (finalAmPm == 'PM' || this.amorpm1 == true) {
      this.amorpm1 = true;
    }

    let arrayLength = this.MeetingRoomDetails?.parkMeetingRoomTimeSlabList.length - 1;
    console.log(this.MeetingRoomDetails?.parkMeetingRoomTimeSlabList[arrayLength].toTime);
    let finalToTime = (this.MeetingRoomDetails?.parkMeetingRoomTimeSlabList[arrayLength].toTime != null) ? this.MeetingRoomDetails?.parkMeetingRoomTimeSlabList[arrayLength].toTime.split(' ')[1] : 'AM';
    console.log(finalToTime);
    if (finalToTime == 'AM') {
      this.amorpm1 = false;
    } else {
      this.amorpm1 = true;
    }
  }

  onTimeChangeRate1_BKP_AM_PM(e, index) {
    console.log(e);
    this.tempEndTimeRate = e;

    if (e.hour == 12 || e.hour > 12) {
      this.amorpm3 = true;
    }
    if (e.hour == 0 || e.hour < 12) {
      this.amorpm3 = false;
    }

    this.endTimePlaceholderRate =
      ('0' + (e.hour > 12 ? e.hour - 12 : e.hour)).slice(-2) +
      ':' +
      ('0' + e.minute).slice(-2) +
      ' ' +
      (e.hour > 12 || this.amorpm3 ? 'PM' : 'AM');
    this.TempRateCardHourCal.forEach((res, i) => {
      this.TempRateCardHourCal[index].etimerate = this.endTimePlaceholderRate;
    });
    // if (e.hour >= 12 || this.amorpm1) {
    //   this.amorpm1 = true;
    // } else {
    //   this.amorpm1 = false;
    // }
    if (e.hour >= 12) {
      this.amorpm3 = true;
    }
    if (e.hour == 0 || e.hour < 12) {
      this.amorpm3 = false;
    }
  }

  onTimeChangeRate1(e, index) {
    console.log(e);
    this.tempEndTimeRate = e;

    this.endTimePlaceholderRate =
      ('0' + (e.hour > 12 ? e.hour - 12 : e.hour == 0 ? 12 : e.hour)).slice(-2) +
      ':' +
      ('0' + e.minute).slice(-2) +
      ' ' +
      (this.amorpm3 ? 'PM' : 'AM');
    this.TempRateCardHourCal.forEach((res, i) => {
      this.TempRateCardHourCal[index].etimerate = this.endTimePlaceholderRate;
    });

    let firstPlaceHolder = this.endTimePlaceholderRate.split(':');
    let splitedfirstPlaceHolder = firstPlaceHolder[0];
    console.log(splitedfirstPlaceHolder);
    let splitAmPm = firstPlaceHolder[1].split(' ');
    let miniutePlaceHolder = splitAmPm[0];
    console.log(miniutePlaceHolder);
    let finalAmPm = splitAmPm[1];
    console.log(finalAmPm);

    this.endTimeRate = { hour: parseInt(splitedfirstPlaceHolder), minute: parseInt(miniutePlaceHolder) };

    this.endTimePlaceholder = this.endTimePlaceholderRate;
    this.endTime = this.endTimeRate;

    if (finalAmPm == 'AM' || this.amorpm3 == false) {
      this.amorpm3 = false;
    }
    if (finalAmPm == 'PM' || this.amorpm3 == true) {
      this.amorpm3 = true;
    }
    this.allDayCheckTimeHourEnd(this.amorpm3);
  }

  onTimeChangeRateChangeOnly1(e, index) {
    console.log(e);
    this.tempEndTimeRate = e;

    console.log(this.amorpm3);
    if (this.amorpm3 == true && e.hour < 12) {
      this.endTimeRate = { hour: e.hour + 12, minute: e.minute }
    }
    if (this.amorpm3 == true && e.hour == 0) {
      this.endTimeRate = { hour: e.hour + 12, minute: e.minute }
    }
    if (this.amorpm3 == false && e.hour > 12) {
      this.endTimeRate = { hour: e.hour - 12, minute: e.minute }
    }
    if (this.amorpm3 == false && e.hour == 12) {
      this.endTimeRate = { hour: e.hour - 12, minute: e.minute }
    }

    console.log(this.amorpm3);

    if (e.hour == 0) {
      this.endTimePlaceholderRate =
        ('0' + (e.hour == 0 ? e.hour + 12 : e.hour)).slice(-2) +
        ':' +
        ('0' + e.minute).slice(-2) +
        ' ' +
        (this.amorpm3 ? 'PM' : 'AM');
    } else {
      this.endTimePlaceholderRate =
        ('0' + (e.hour >= 12 ? e.hour - 12 : e.hour)).slice(-2) +
        ':' +
        ('0' + e.minute).slice(-2) +
        ' ' +
        (this.amorpm3 ? 'PM' : 'AM');
    }
    this.TempRateCardHourCal.forEach((res, i) => {
      console.log(res);
      console.log(index);
      this.TempRateCardHourCal[index].etimerate = this.endTimePlaceholderRate;
    });
  }

  convertFormat(y, m, d) {
    return y + '-' + m + '-' + d;
  }

  onSelectFile_bkp(event) {
    const name = event.target.files[0].name;
    const lastDot = name.indexOf('.');
    const ext = name.substring(lastDot + 1).toLowerCase();
    if (
      (ext == 'png' || ext == 'jpg' || ext == 'jpeg') &&
      /^[^<>]*$/.test(name)
    ) {
      if (event.target.files[0].size > 2097152) {
        return this.appStateSrv.showToast('Image size must be less then 2MB');
      }

      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        console.log(e);
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          if (img.width !== 1080 || img.height !== 608) {
            return this.appStateSrv.showToast('Image dimensions should be 1080 px X 608 px');
          }
        };
      };
      reader.readAsDataURL(file);

      this.parkSrv.uploadImage(event).then((data) => {
        const img = {
          imageURL: data,
          imageId: null,
          isActive: true,
        };

        this.TempMeetingRoomImages.push(img);
        this.meetingRoomImages.push(img);

        this.appStateSrv.showToast('Image added successfully');
      });
    } else {
      return this.appStateSrv.showToast(
        'Please upload a valid file in jpg/png/jpeg format only'
      );
    }
  }


  onSelectFile(event) {
    if (!event.target.files || !event.target.files[0]) return;
    const file = event.target.files[0];
    const name = file.name;
    const lastDot = name.indexOf('.');
    const ext = name.substring(lastDot + 1).toLowerCase();

    if (!(ext === 'png' || ext === 'jpg' || ext === 'jpeg') || !/^[^<>]*$/.test(name)) {
      return this.appStateSrv.showToast('Please upload a valid file in jpg/png/jpeg format only');
    }
    if (file.size > 2097152) {
      return this.appStateSrv.showToast('Image size must be less than 2MB');
    }

    const blobUrlRaw = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      if (img.width !== 1080 || img.height !== 608) {
        URL.revokeObjectURL(blobUrlRaw);
        return this.appStateSrv.showToast('Image dimensions should be 1080 px X 608 px');
      }
      const imgData = {
        imageURL: this.sanitizer.bypassSecurityTrustUrl(blobUrlRaw) as any,
        imageId: null,
        isActive: true,
        imgFile: file,
        _blobUrlRaw: blobUrlRaw,
      };
      this.TempMeetingRoomImages.push(imgData);
      this.meetingRoomImages.push(imgData);
      this.appStateSrv.showToast('Image added successfully');
    };
    img.onerror = () => {
      URL.revokeObjectURL(blobUrlRaw);
      return this.appStateSrv.showToast('Invalid image file');
    };
    img.src = blobUrlRaw;
  }


  delete(event, id, i) {
    const idxTemp = this.TempMeetingRoomImages.indexOf(event);
    if (idxTemp >= 0) this.TempMeetingRoomImages.splice(idxTemp, 1);

    const idxFac = this.meetingRoomImages.findIndex(
      (el) => el === event || (id != null && el?.imageId === id) || el?.imageURL === event?.imageURL
    );
    if (idxFac === -1) return;

    const item = this.meetingRoomImages[idxFac];
    item.isActive = false;

    if (item && item.imgFile && item._blobUrlRaw) {
      URL.revokeObjectURL(item._blobUrlRaw);
    }
  }

  // dropdown

  onClickedOutside(e: Event) {
    this.time1 = false;
    this.time2 = false;
    this.mtsDate = false;
    this.mteDate = false;
    this.repeateTestPlaceHolder = false;
    // console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  openPopoverRateCard_BKP_AMPM(popover, event, index) {
    console.log(event);
    console.log(index);
    console.log(event[index].stimerate);
    if (event[index].stimerate != null) {
      let sttm = event[index].stimerate.split(':');
      if (sttm[0].charAt(0) === '0') {
        this.startTimeRate = { hour: parseInt(sttm[0].slice(1)), minute: parseInt(sttm[1].split(' ')[0].slice(1)) };
      } else {
        this.startTimeRate = { hour: parseInt(sttm[0]), minute: parseInt(sttm[1].split(' ')[0]) };
      }
      if (sttm[1].split(' ')[1] == 'PM') {
        this.amorpm2 = true;
        if (this.startTimeRate.hour != 12) {
          this.startTimeRate = { hour: this.startTimeRate.hour + 12, minute: this.startTimeRate.minute };
        }
      } else {
        this.amorpm2 = false;
      }
      // this.startTimeRate = { hour: this.endTimeRate.hour - 1, minute: this.endTimeRate.minute }; // { hour: 5, minute: 0 };
    } else {
      this.startTimeRate = { hour: 5, minute: 0 };
      this.amorpm2 = false;
    }

    if (event[index].etimerate != null) {
      let ettm = event[index].etimerate.split(':');
      if (ettm[0].charAt(0) === '0') {
        this.endTimeRate = { hour: parseInt(ettm[0].slice(1)), minute: parseInt(ettm[1].split(' ')[0].slice(1)) };
      } else {
        this.endTimeRate = { hour: parseInt(ettm[0]), minute: parseInt(ettm[1].split(' ')[0]) };
      }
      if (ettm[1].split(' ')[1] == 'PM') {
        this.amorpm3 = true;
        if (this.endTimeRate.hour != 12) {
          this.endTimeRate = { hour: this.endTimeRate.hour + 12, minute: this.endTimeRate.minute };
        }
      } else {
        this.amorpm3 = false;
      }
    } else {
      this.endTimeRate = { hour: this.startTimeRate.hour + 1, minute: this.startTimeRate.minute }; // { hour: 5, minute: 0 };
      this.amorpm3 = this.amorpm2; // false;
    }

    this.startTimePlaceholderRate =
      ('0' + (this.startTimeRate.hour > 12 ? this.startTimeRate.hour - 12 : this.startTimeRate.hour)).slice(-2) +
      ':' +
      ('0' + this.startTimeRate.minute).slice(-2) +
      ' ' +
      (this.startTimeRate.hour > 12 || this.amorpm2 ? 'PM' : 'AM');

    this.endTimePlaceholderRate =
      ('0' + (this.endTimeRate.hour > 12 ? this.endTimeRate.hour - 12 : this.endTimeRate.hour)).slice(-2) +
      ':' +
      ('0' + this.endTimeRate.minute).slice(-2) +
      ' ' +
      (this.endTimeRate.hour > 12 || this.amorpm3 ? 'PM' : 'AM');


    this.TempRateCardHourCal[index].stimerate = this.startTimePlaceholderRate;
    // this.TempRateCardHourCal[index].etimerate = this.endTimePlaceholderRate;
    console.log(this.startTimeRate);
    console.log(this.endTimeRate);

    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }


  openPopoverRateCard(popover, event, index) {
    if (event[index].stimerate != null) {
      let sttm = event[index].stimerate.split(':');
      if (sttm[0].charAt(0) === '0') {
        this.startTimeRate = { hour: parseInt(sttm[0].slice(1)), minute: parseInt(sttm[1].split(' ')[0].slice(1)) };
      } else {
        this.startTimeRate = { hour: parseInt(sttm[0]), minute: parseInt(sttm[1].split(' ')[0]) };
      }
      if (sttm[1].split(' ')[1] == 'PM') {
        this.amorpm2 = true;
        if (this.startTimeRate.hour != 12) {
          this.startTimeRate = { hour: this.startTimeRate.hour + 12, minute: this.startTimeRate.minute };
        }
      } else {
        this.amorpm2 = false;
      }
      // this.startTimeRate = { hour: this.endTimeRate.hour, minute: this.endTimeRate.minute }; // { hour: 7, minute: 0 };
    } else {
      if (this.deleteTimeWithHour.hour != 0) {
        this.startTimeRate = { hour: this.deleteTimeWithHour.hour, minute: this.deleteTimeWithHour.minute };
        this.amorpm2 = this.deleteamorpm;
        this.deleteTimeWithHour = { hour: 0, minute: 0 };
      } else {
        this.startTimeRate = { hour: this.endTimeRate.hour, minute: this.endTimeRate.minute }; // { hour: 7, minute: 0 };
        this.amorpm2 = this.amorpm3; // false;
      }
    }

    if (event[index].etimerate != null) {
      let ettm = event[index].etimerate.split(':');
      if (ettm[0].charAt(0) === '0') {
        this.endTimeRate = { hour: parseInt(ettm[0].slice(1)), minute: parseInt(ettm[1].split(' ')[0].slice(1)) };
      } else {
        this.endTimeRate = { hour: parseInt(ettm[0]), minute: parseInt(ettm[1].split(' ')[0]) };
      }
      if (ettm[1].split(' ')[1] == 'PM') {
        this.amorpm3 = true;
        if (this.endTimeRate.hour != 12) {
          this.endTimeRate = { hour: this.endTimeRate.hour + 12, minute: this.endTimeRate.minute };
        }
      } else {
        this.amorpm3 = false;
      }
    } else {
      this.endTimeRate = { hour: this.startTimeRate.hour + 1, minute: this.startTimeRate.minute }; // { hour: 7, minute: 0 };
      this.amorpm3 = this.amorpm2; // false;
    }

    this.startTimePlaceholderRate =
      ('0' + (this.startTimeRate.hour > 12 ? this.startTimeRate.hour - 12 : this.startTimeRate.hour == 0 ? 12 : this.startTimeRate.hour)).slice(-2) +
      ':' +
      ('0' + this.startTimeRate.minute).slice(-2) +
      ' ' +
      (this.startTimeRate.hour > 12 || this.amorpm2 ? 'PM' : 'AM');

    this.endTimePlaceholderRate =
      ('0' + (this.endTimeRate.hour > 12 ? this.endTimeRate.hour - 12 : this.endTimeRate.hour)).slice(-2) +
      ':' +
      ('0' + this.endTimeRate.minute).slice(-2) +
      ' ' +
      (this.endTimeRate.hour > 12 || this.amorpm3 ? 'PM' : 'AM');

    // this.startTimePlaceholder = this.startTimePlaceholderRate;
    // this.startTime = this.startTimeRate;

    if (index > 0) {
      if (this.TempRateCardHourCal[index - 1].etimerate != null && this.TempRateCardHourCal[index - 1].etimerate != undefined || this.TempRateCardHourCal[index - 1].etimerate != '') {
        this.startTimePlaceholderRate = this.TempRateCardHourCal[index - 1].etimerate;
      }
    }

    this.TempRateCardHourCal[index].stimerate = this.startTimePlaceholderRate;
    // this.TempRateCardHourCal[index].etimerate = this.endTimePlaceholderRate;
    console.log(this.startTimeRate);
    console.log(this.endTimeRate);

    //additional adding
    let firstPlaceHolder = this.startTimePlaceholderRate.split(':');
    let splitedfirstPlaceHolder = firstPlaceHolder[0];
    console.log(splitedfirstPlaceHolder);
    let splitAmPm = firstPlaceHolder[1].split(' ');
    let miniutePlaceHolder = splitAmPm[0];
    console.log(miniutePlaceHolder);
    let finalAmPm = splitAmPm[1];
    console.log(finalAmPm);

    this.startTimeRate = { hour: parseInt(splitedfirstPlaceHolder), minute: parseInt(miniutePlaceHolder) };
    if (finalAmPm == 'AM' || this.amorpm2 == false) {
      this.amorpm2 = false;
    }
    if (finalAmPm == 'PM' || this.amorpm2 == true) {
      this.amorpm2 = true;
    }

    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  openPopoverRateCardEndTime_BKP_AMPM(popover, event, index) {
    console.log(event);
    console.log(index);
    if (event[index].stimerate != null) {
      let sttm = event[index].stimerate.split(':');
      if (sttm[0].charAt(0) === '0') {
        this.startTimeRate = { hour: parseInt(sttm[0].slice(1)), minute: parseInt(sttm[1].split(' ')[0].slice(1)) };
      } else {
        this.startTimeRate = { hour: parseInt(sttm[0]), minute: parseInt(sttm[1].split(' ')[0]) };
      }
      if (sttm[1].split(' ')[1] == 'PM') {
        this.amorpm2 = true;
        if (this.startTimeRate.hour != 12) {
          this.startTimeRate = { hour: this.startTimeRate.hour + 12, minute: this.startTimeRate.minute };
        }
      } else {
        this.amorpm2 = false;
      }
    } else {
      this.startTimeRate = { hour: 5, minute: 0 };
      this.amorpm2 = false;
    }

    if (event[index].etimerate != null) {
      let ettm = event[index].etimerate.split(':');
      if (ettm[0].charAt(0) === '0') {
        this.endTimeRate = { hour: parseInt(ettm[0].slice(1)), minute: parseInt(ettm[1].split(' ')[0].slice(1)) };
      } else {
        this.endTimeRate = { hour: parseInt(ettm[0]), minute: parseInt(ettm[1].split(' ')[0]) };
      }
      if (ettm[1].split(' ')[1] == 'PM') {
        this.amorpm3 = true;
        if (this.endTimeRate.hour != 12) {
          this.endTimeRate = { hour: this.endTimeRate.hour + 12, minute: this.endTimeRate.minute };
        }
      } else {
        this.amorpm3 = false;
      }
      // this.endTimeRate = { hour: this.startTimeRate.hour + 1, minute: this.startTimeRate.minute }; // { hour: 5, minute: 0 };
      // if (this.endTimeRate.hour == 12 && this.amorpm == false) {
      //   this.amorpm = true;
      //   this.amorpm1 = true;
      // } else if (this.endTimeRate.hour == 24 && this.amorpm == true) {
      //   this.amorpm = false;
      //   this.amorpm1 = false;
      // } else {
      //   this.amorpm1 = this.amorpm; // false;
      // }
    } else {
      this.endTimeRate = { hour: this.startTimeRate.hour + 1, minute: this.startTimeRate.minute }; // { hour: 5, minute: 0 };
      if (this.endTimeRate.hour == 12 && this.amorpm2 == false) {
        this.amorpm2 = true;
        this.amorpm3 = true;
      } else if (this.endTimeRate.hour == 24 && this.amorpm2 == true) {
        this.amorpm2 = false;
        this.amorpm3 = false;
      } else {
        this.amorpm3 = this.amorpm2; // false;
      }
    }

    this.startTimePlaceholderRate =
      ('0' + (this.startTimeRate.hour > 12 ? this.startTimeRate.hour - 12 : this.startTimeRate.hour)).slice(-2) +
      ':' +
      ('0' + this.startTimeRate.minute).slice(-2) +
      ' ' +
      (this.startTimeRate.hour > 12 || this.amorpm2 ? 'PM' : 'AM');

    if (this.endTimeRate.hour == 24) {
      this.endTimePlaceholderRate =
        ('0' + (this.endTimeRate.hour == 24 ? this.endTimeRate.hour - 24 : this.endTimeRate.hour)).slice(-2) +
        ':' +
        ('0' + this.endTimeRate.minute).slice(-2) +
        ' ' +
        (this.endTimeRate.hour == 24 || this.amorpm3 ? 'AM' : 'AM');
    } else {
      this.endTimePlaceholderRate =
        ('0' + (this.endTimeRate.hour > 12 ? this.endTimeRate.hour - 12 : this.endTimeRate.hour)).slice(-2) +
        ':' +
        ('0' + this.endTimeRate.minute).slice(-2) +
        ' ' +
        (this.endTimeRate.hour > 12 || this.amorpm3 ? 'PM' : 'AM');
    }

    // this.TempRateCardHourCal[index].stimerate = this.startTimePlaceholderRate;
    this.TempRateCardHourCal[index].etimerate = this.endTimePlaceholderRate;
    console.log(this.startTimeRate);
    console.log(this.endTimeRate);

    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  openPopoverRateCardEndTime(popover, event, index) {
    if (event[index].stimerate != null) {
      let sttm = event[index].stimerate.split(':');
      if (sttm[0].charAt(0) === '0') {
        this.startTimeRate = { hour: parseInt(sttm[0].slice(1)), minute: parseInt(sttm[1].split(' ')[0].slice(1)) };
      } else {
        this.startTimeRate = { hour: parseInt(sttm[0]), minute: parseInt(sttm[1].split(' ')[0]) };
      }
      if (sttm[1].split(' ')[1] == 'PM') {
        this.amorpm2 = true;
        if (this.startTimeRate.hour != 12) {
          this.startTimeRate = { hour: this.startTimeRate.hour + 12, minute: this.startTimeRate.minute };
        }
      } else {
        this.amorpm2 = false;
      }
    } else {
      this.startTimeRate = { hour: 7, minute: 0 };
      this.amorpm2 = false;
    }

    console.log(event[index].etimerate);
    if (event[index].etimerate != null) {
      let ettm = event[index].etimerate.split(':');
      if (ettm[0].charAt(0) === '0') {
        this.endTimeRate = { hour: parseInt(ettm[0].slice(1)), minute: parseInt(ettm[1].split(' ')[0].slice(1)) };
      } else {
        this.endTimeRate = { hour: parseInt(ettm[0]), minute: parseInt(ettm[1].split(' ')[0]) };
      }
      if (ettm[1].split(' ')[1] == 'PM') {
        this.amorpm3 = true;
        if (this.endTimeRate.hour != 12) {
          this.endTimeRate = { hour: this.endTimeRate.hour + 12, minute: this.endTimeRate.minute };
        }
      } else {
        this.amorpm3 = false;
      }
      // this.endTimeRate = { hour: this.startTimeRate.hour + 1, minute: this.startTimeRate.minute }; // { hour: 5, minute: 0 };
      // if (this.endTimeRate.hour == 12 && this.amorpm == false) {
      //   this.amorpm = true;
      //   this.amorpm1 = true;
      // } else if (this.endTimeRate.hour == 24 && this.amorpm == true) {
      //   this.amorpm = false;
      //   this.amorpm1 = false;
      // } else {
      //   this.amorpm1 = this.amorpm; // false;
      // }
    } else {
      this.endTimeRate = { hour: this.startTimeRate.hour + 1, minute: this.startTimeRate.minute }; // { hour: 5, minute: 0 };
      if (this.endTimeRate.hour == 12 && this.amorpm2 == false) {
        this.amorpm2 = true;
        this.amorpm3 = true;
      } else if (this.endTimeRate.hour == 24 && this.amorpm2 == true) {
        this.amorpm2 = false;
        this.amorpm3 = false;
      } else {
        this.amorpm3 = this.amorpm2; // false;
      }
    }

    this.startTimePlaceholderRate =
      ('0' + (this.startTimeRate.hour > 12 ? this.startTimeRate.hour - 12 : this.startTimeRate.hour)).slice(-2) +
      ':' +
      ('0' + this.startTimeRate.minute).slice(-2) +
      ' ' +
      (this.amorpm2 ? 'PM' : 'AM');

    if (this.endTimeRate.hour == 24) {
      this.endTimePlaceholderRate =
        ('0' + (this.endTimeRate.hour == 24 ? this.endTimeRate.hour - 12 : this.endTimeRate.hour == 0 ? 12 : this.endTimeRate.hour)).slice(-2) +
        ':' +
        ('0' + this.endTimeRate.minute).slice(-2) +
        ' ' +
        (this.amorpm3 ? 'AM' : 'AM');
    } else {
      this.endTimePlaceholderRate =
        ('0' + (this.endTimeRate.hour > 12 ? this.endTimeRate.hour - 12 : this.endTimeRate.hour == 0 ? 12 : this.endTimeRate.hour)).slice(-2) +
        ':' +
        ('0' + this.endTimeRate.minute).slice(-2) +
        ' ' +
        (this.amorpm3 ? 'PM' : 'AM');
    }

    this.endTimePlaceholder = this.endTimePlaceholderRate;
    this.endTime = this.endTimeRate;

    // this.TempRateCardHourCal[index].stimerate = this.startTimePlaceholderRate;
    this.TempRateCardHourCal[index].etimerate = this.endTimePlaceholderRate;
    console.log(this.startTimeRate);
    console.log(this.endTimeRate);

    //addition adding
    let firstPlaceHolder = this.endTimePlaceholderRate.split(':');
    let splitedfirstPlaceHolder = firstPlaceHolder[0];
    console.log(splitedfirstPlaceHolder);
    let splitAmPm = firstPlaceHolder[1].split(' ');
    let miniutePlaceHolder = splitAmPm[0];
    console.log(miniutePlaceHolder);
    let finalAmPm = splitAmPm[1];
    console.log(finalAmPm);

    this.endTimeRate = { hour: parseInt(splitedfirstPlaceHolder), minute: parseInt(miniutePlaceHolder) };
    if (finalAmPm == 'AM' || this.amorpm3 == false) {
      this.amorpm3 = false;
    }
    if (finalAmPm == 'PM' || this.amorpm3 == true) {
      this.amorpm3 = true;
    }

    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  checkOverlap(timeslabs) {
    // Handle timestamp interpretation (inclusive or exclusive)
    const inclusive = false; // Set to true if you want timestamps to be part of their respective slabs

    for (let i = 0; i < timeslabs.length; i++) {
      const slab1 = timeslabs[i];

      for (let j = i + 1; j < timeslabs.length; j++) {
        const slab2 = timeslabs[j];

        // Adjust times according to inclusive/exclusive handling
        const slab1StartTime = inclusive ? new Date(slab1.stimerate) : new Date(slab1.stimerate);
        slab1StartTime.setMinutes(slab1StartTime.getMinutes() + (inclusive ? 0 : -1)); // Adjust for inclusivity
        const slab1EndTime = inclusive ? new Date(slab1.etimerate) : new Date(slab1.etimerate);
        slab1EndTime.setMinutes(slab1EndTime.getMinutes() + (inclusive ? 0 : 1)); // Adjust for inclusivity

        const slab2StartTime = inclusive ? new Date(slab2.stimerate) : new Date(slab2.stimerate);
        slab2StartTime.setMinutes(slab2StartTime.getMinutes() + (inclusive ? 0 : -1)); // Adjust for inclusivity
        const slab2EndTime = inclusive ? new Date(slab2.etimerate) : new Date(slab2.etimerate);
        slab2EndTime.setMinutes(slab2EndTime.getMinutes() + (inclusive ? 0 : 1)); // Adjust for inclusivity

        // Check for overlap using inclusive/exclusive logic
        const overlaps = (slab1StartTime < slab2EndTime && slab1EndTime > slab2StartTime) ||
          (slab2StartTime < slab1EndTime && slab2EndTime > slab1StartTime);

        if (overlaps) {
          // Overlap detected: handle it here (log, display an alert, etc.)
          console.error(`Overlap detected between slabs ${slab1.parkMeetingRoomTimeSlabListId} and ${slab2.parkMeetingRoomTimeSlabListId}`);
          return true; // If you want to stop checking after the first overlap, uncomment this line
        }
      }
    }

    return false; // No overlaps found
  }

  // Define a function to check for overlapping time slots
  checkForOverlap(timeSlots: any[]): boolean {
    for (let i = 0; i < timeSlots.length; i++) {
      for (let j = i + 1; j < timeSlots.length; j++) {
        const fromTime1 = new Date('1970-01-01 ' + timeSlots[i].stimerate);
        const toTime1 = new Date('1970-01-01 ' + timeSlots[i].etimerate);
        const fromTime2 = new Date('1970-01-01 ' + timeSlots[j].stimerate);
        const toTime2 = new Date('1970-01-01 ' + timeSlots[j].etimerate);

        if (fromTime1 < toTime2 && toTime1 > fromTime2) {
          return true; // Overlap detected
        }
      }
    }
    return false; // No overlap detected
  }

  setProperty(property) {
    this.propTypeId = property.parkTypeId;
    this.propType = property.parkTypeName;
  }

  enterName(field) {
    console.log(field);
    //this.stimeratePlaceHolder = false;
    //this.etimeratePlaceHolder = false;
    if (field == 'propertyType') {
      this.propertyType = !this.propertyType;
    }
    if (field == 'propertyName') {
      this.propertyName = !this.propertyName;
    }
    if (field == 'amt') {
      this.amt = !this.amt;
    }
    if (field == 'hourAdditional') {
      this.hourAdd = !this.hourAdd;
    }
    if (field == 'dailyRate') {
      this.dailyR = !this.dailyR;
    }
    if (field == 'dailyAdditional') {
      this.dailyAdd = !this.dailyAdd;
    }
    if (field == 'amtDeducted') {
      this.amtDeducted = !this.amtDeducted;
    }
    if (field == 'min') {
      this.min = !this.min;
    }
    if (field == 'unitType') {
      this.unitType = !this.unitType;
    }
    if (field == 'mobile') {
      this.mobile = !this.mobile;
    }
    if (field == 'email') {
      this.email = !this.email;
    }

    if (field == 'startDate') {
      this.sDate = !this.sDate;
      if (this.formatDate != undefined) {
        this.sDate = true;
      }
    }
    if (field == 'endDate') {
      this.eDate = !this.eDate;
      if (this.formatToDate != undefined) {
        this.eDate = true;
      }
    }
    if (field == 'stimerate') {
      this.stimerate = !this.stimerate;
    }
    if (field == 'etimerate') {
      this.etimerate = !this.etimerate;
    }
    if (field == 'mtstime') {
      this.mtstime = !this.mtstime;
    }
    if (field == 'etimerate') {
      this.mtetime = !this.mtetime;
    }
    if (field == 'stimeratePlaceHolder') {
      this.stimeratePlaceHolder = !this.stimeratePlaceHolder;
    }
    if (field == 'etimeratePlaceHolder') {
      this.etimeratePlaceHolder = !this.etimeratePlaceHolder;
    }
  }

  enterNameRateCard(field) {
    if (field == 'hourRate') {
      this.hourR = !this.hourR;
    }
  }

  setUnitType(item, i) {
    console.log(item);
    console.log(this.TempMeetingRoomCanCal);
    this.TempMeetingRoomCanCal[i].unitType = item.facilityUnitType;
    this.meetingRoomCanCal[i].unitTypeId = item.facilityUnitTypeId;
  }

  addTnc() {
    const data = {
      meetingRoomTncid: null,
      isActive: true,
      termDescription: null,
    };
    this.TempMeetingRoomTnc.push(data);
    this.meetingRoomTnc.push(data);
  }

  deleteTnC(i) {
    this.TempMeetingRoomTnc.splice(i, 1);
    this.meetingRoomTnc[i].isActive = false;
  }

  addCalc() {
    const data = {
      meetingRoomCancellationCalculationId: null,
      isActive: true,
      timePrior: '0',
      unitType: null,
      amountDeducted: 0,
    };
    this.TempMeetingRoomCanCal.push(data);
    this.meetingRoomCanCal.push(data);
  }

  deleteCalc(i) {
    this.TempMeetingRoomCanCal.splice(i, 1);
    this.meetingRoomCanCal[i].isActive = false;
  }

  addMultipleRate() {

    const data5 = {
      parkMeetingRoomTimeSlabListId: null,
      isActive: true,
      hourRate: 0,
      stimerate: null,
      etimerate: null,
    };
    this.TempRateCardHourCal.push(data5);

    this.deleteTimeWithHour = { hour: 0, minute: 0 };
  }

  deleteMultipleRate(i) {
    this.TempRateCardHourCal.splice(i, 1);
    // this.meetingRoomCanCal[i].isActive = false;

    this.TempRateCardHourCalDelete = this.TempRateCardHourCal.filter(item => item.stimerate && item.etimerate);
    let event = this.TempRateCardHourCalDelete[this.TempRateCardHourCalDelete.length - 1];
    if (event.etimerate != null) {
      let sttm = event.etimerate.split(':');
      if (sttm[0].charAt(0) === '0') {
        this.deleteTimeWithHour = { hour: parseInt(sttm[0].slice(1)), minute: parseInt(sttm[1].split(' ')[0].slice(1)) };
      } else {
        this.deleteTimeWithHour = { hour: parseInt(sttm[0]), minute: parseInt(sttm[1].split(' ')[0]) };
      }
      if (sttm[1].split(' ')[1] == 'PM') {
        this.deleteamorpm = true;
      } else {
        this.deleteamorpm = false;
      }
    }
    console.log(this.deleteTimeWithHour);
    console.log(this.deleteamorpm);
    this.checkHourTimeWithDay();
  }

  addPolicy() {
    const data = {
      policyDescription: '',
      meetingRoomPolicyId: null,
      isActive: true,
    };
    this.TempMeetingRoomPolicies.push(data);
    this.meetingRoomPolicy.push(data);
  }

  deletePolicy(i) {
    this.TempMeetingRoomPolicies.splice(i, 1);
    this.meetingRoomPolicy[i].isActive = false;
  }

  addContact() {
    const data = {
      contactEmail: '',
      meetingRoomContactId: null,
      contactNumber: null,
      isActive: true,
    };
    this.TempMeetingRoomContacts.push(data);
    this.meetingRoomContacts.push(data);
  }

  // removeContact(i) {
  //   this.TempMeetingRoomContacts.splice(i, 1);
  //   this.meetingRoomContacts[i].isActive = false;
  // }

  removeContact(i) {
    console.log(i);
    this.TempMeetingRoomContacts.splice(i, 1);
    this.meetingRoomContacts[i].isActive = false;
    this.meetingRoomContacts.slice(i, 1);
    console.log(this.meetingRoomContacts);
    console.log(this.TempMeetingRoomContacts);
  }

  toggleSecurity() {
    const ele = document.getElementById('security') as HTMLInputElement;
    this.showSecurity = ele.checked ? true : false;
  }

  toggleMeetingRoom() {
    const ele = document.getElementById('facility') as HTMLInputElement;
    this.showMeetingRoom = ele.checked ? true : false;
    if (this.showMeetingRoom === false) {
      this.showBooking = false;
      this.bookingCapaciltyVal = false;
    }
  }

  toggleBooking() {
    const ele = document.getElementById('booking') as HTMLInputElement;
    this.showBooking = ele.checked ? true : false;
  }

  setmeetinRoomVal(val) {
    console.log(val);
    this.meetingRoomCapacilty = Number(this.meetingRoomCapacilty) + val;
  }

  setbookingVal(val) {
    console.log(val);
    this.capacity = Number(this.capacity) + val;
  }

  setminDurationVal(val) {
    console.log(val);
    this.minbookingDuration = Number(this.minbookingDuration) + val;
  }

  setmaxDurationVal(val) {
    console.log(val);
    this.maxbookingDuration = Number(this.maxbookingDuration) + val;
  }

  setDurationValForMaintenance(val) {
    console.log(val);
    this.repeatEveryType = Number(this.repeatEveryType) + val;
  }

  setminDurationValAutoCncl(val) {
    console.log(val);
    this.minAutoCancelDuration = Number(this.minAutoCancelDuration) + val;
  }

  selectType(type) {
    console.log(type.target.value);
    this.type = type.target.value;
    if (type.target.value == 'cal') {
      this.showCal = true;
      this.showPolicy = false;
    } else {
      this.showCal = false;
      this.showPolicy = true;
    }
  }

  selectZone(type) {
    console.log(type);
    if (type.toLowerCase() == 'sez') {
      this.zoneId = this.gstDetail[0].taxSlabId;
      this.zoneVal = 'sez';
    } else {
      this.zoneId = this.gstDetail[1].taxSlabId;
      this.zoneVal = 'nonSez';
    }
    // }
  }

  open(content) {
    console.log(content);
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'custom-class',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  toggle(type, team) {
    this.toggleType = type;
    this.activation = team;
    this.statusText = this.activation ? 'disable' : 'enable';
    if (type == 'security') {
      this.securityDepositVal = !this.securityDepositVal;
      this.open(this.contentSecurity);
    }
    if (type == 'facility') {
      this.meetingRoomCapaciltyVal = !this.meetingRoomCapaciltyVal;
      this.open(this.contentMeetingRoom);
    }
    if (type == 'booking') {
      this.bookingCapaciltyVal = !this.bookingCapaciltyVal;
      this.open(this.contentBooking);
    }
    this.capacity = 1;
  }

  onCancel() {
    if (this.toggleType == 'security') {
      this.securityDepositVal = !this.securityDepositVal;
    }
    if (this.toggleType == 'facility') {
      this.meetingRoomCapaciltyVal = !this.meetingRoomCapaciltyVal;
    }
    if (this.toggleType == 'booking') {
      this.bookingCapaciltyVal = !this.bookingCapaciltyVal;
    }
  }

  onSelected(data) {

    console.log(data.target.value);

    this.repeatTypeValue = data.target.value;

    this.selectedDaily = false;
    this.selectedWeekly = false;
    this.selectedMonthly = false;
    this.selectedYearly = false;
    this.minRepeat = 0;
    this.maxRepeat = 0;
    this.stepRepeat = 1;
    this.weeklyValueRequired = false;

    if (data.target.value == '0') {
      this.selectedDaily = true;
      this.repeatEveryText = 'Day(s)';
      this.minRepeat = 1;
      this.maxRepeat = 31;
      this.weekNameArray = [];
    }
    if (data.target.value == '1') {
      this.selectedWeekly = true;
      this.repeatEveryText = 'Week(s)';
      this.minRepeat = 1;
      this.maxRepeat = 4;
      this.weeksOfOperation.forEach(day => {
        day.selected = false;
      });
    }
    if (data.target.value == '2') {
      this.selectedMonthly = true;
      this.repeatEveryText = 'Month(s)';
      this.minRepeat = 1;
      this.maxRepeat = 12;
      this.weekNameArray = [];
      this.monthlyRepeateOnModel = "1";
      this.monthlyRepeateOnWeekName = '1'; // select day
      this.monthlyRepeateOnWeekStarting = '0'; //select every
      this.monthsOfOperationModel = '0';
      this.monthDateValueModel = '1';
    }
    if (data.target.value == '3') {
      this.selectedYearly = true;
      this.repeatEveryText = 'Year(s)';
      this.minRepeat = 1;
      this.maxRepeat = 99;
      this.weekNameArray = [];
      this.monthlyRepeateOnModel = "1";
      this.monthlyRepeateOnWeekName = '1'; // select day
      this.monthlyRepeateOnWeekStarting = '0'; //select every
      this.monthsOfOperationModel = '0';
      this.monthDateValueModel = '1';
    }

    this.repeatEveryType = 1;
  }

  onSelectedClick(data) {

    this.selectedDailyClick = false;
    this.selectedWeeklyClick = false;
    this.selectedMonthlyClick = false;
    this.selectedYearlyClick = false;

    if (data.target.value === 'DailyUntil') {
      this.selectedDailyClick = true;
    }
    if (data.target.value === 'WeekUntil') {
      this.selectedWeeklyClick = true;
    }
    if (data.target.value === 'MonthUntil') {
      this.selectedMonthlyClick = true;
    }
    if (data.target.value === 'YearUntil') {
      this.selectedYearlyClick = true;
    }
  }

  //Maintenance
  toggleAmPmSelectionMaintenance(value: boolean) {
    console.log(value)
    this.amorpm4 = value;
    this.tempTime = this.startTimeMaintenance;
    this.onTimeChangeMaintenance(this.tempTime);
  }

  toggleAmPmSelectionMaintenance1(value: boolean) {
    this.amorpm5 = value;
    this.tempEndTime = this.endTimeMaintenance;
    this.onTimeChangeMaintenance1(this.tempEndTime);
  }

  onTimeChangeMaintenance(e) {
    console.log(e);
    this.tempTime = e;
    console.log(this.amorpm4);

    this.startTimePlaceholderMaint =
      ('0' + (e.hour > 12 ? e.hour - 12 : e.hour == 0 ? 12 : e.hour)).slice(-2) +
      ':' +
      ('0' + e.minute).slice(-2) +
      ' ' +
      (this.amorpm4 ? 'PM' : 'AM');

    // console.log(this.startTimePlaceholderMaint);
    // this.endTimePlaceholderMaint = this.addOneHour(this.startTimePlaceholderMaint);

    let firstPlaceHolder = this.startTimePlaceholderMaint.split(':');
    let splitedfirstPlaceHolder = firstPlaceHolder[0];
    let splitAmPm = firstPlaceHolder[1].split(' ');
    let miniutePlaceHolder = splitAmPm[0];
    let finalAmPm = splitAmPm[1];

    this.startTimeMaintenance = { hour: parseInt(splitedfirstPlaceHolder), minute: parseInt(miniutePlaceHolder) };
    if (finalAmPm == 'AM' || this.amorpm4 == false) {
      this.amorpm4 = false;
    }
    if (finalAmPm == 'PM' || this.amorpm4 == true) {
      this.amorpm4 = true;
    }

    // this.endTimeMaintenance = this.addOneHourTimeFormat(this.startTimeMaintenance);
    // this.amorpm5 = this.amorpm4;

    console.log(this.amorpm4);
  }

  onTimeChangeMaintenance1(e) {
    console.log(e);
    this.tempEndTime = e;

    this.endTimePlaceholderMaint =
      ('0' + (e.hour > 12 ? e.hour - 12 : e.hour == 0 ? 12 : e.hour)).slice(-2) +
      ':' +
      ('0' + e.minute).slice(-2) +
      ' ' +
      (this.amorpm5 ? 'PM' : 'AM');

    let firstPlaceHolder = this.endTimePlaceholderMaint.split(':');
    let splitedfirstPlaceHolder = firstPlaceHolder[0];
    let splitAmPm = firstPlaceHolder[1].split(' ');
    let miniutePlaceHolder = splitAmPm[0];
    let finalAmPm = splitAmPm[1];

    this.endTimeMaintenance = { hour: parseInt(splitedfirstPlaceHolder), minute: parseInt(miniutePlaceHolder) };
    if (finalAmPm == 'AM' || this.amorpm5 == false) {
      this.amorpm5 = false;
    }
    if (finalAmPm == 'PM' || this.amorpm5 == true) {
      this.amorpm5 = true;
    }
  }

  openPopoverMaintenanceStart(popover, event) {
    console.log(event);
    console.log(this.amorpm4);

    this.startTimePlaceholderMaint =
      ('0' + (event.hour > 12 ? event.hour - 12 : event.hour == 0 ? 12 : event.hour)).slice(-2) +
      ':' +
      ('0' + event.minute).slice(-2) +
      ' ' +
      (event.hour >= 12 ? 'PM' : 'AM');

    //additional adding
    let firstPlaceHolder = this.startTimePlaceholderMaint.split(':');
    let splitedfirstPlaceHolder = firstPlaceHolder[0];
    console.log(splitedfirstPlaceHolder);
    let splitAmPm = firstPlaceHolder[1].split(' ');
    let miniutePlaceHolder = splitAmPm[0];
    console.log(miniutePlaceHolder);
    let finalAmPm = splitAmPm[1];
    console.log(finalAmPm);

    this.startTimeMaintenance = { hour: parseInt(splitedfirstPlaceHolder), minute: parseInt(miniutePlaceHolder) };
    if (finalAmPm == 'AM' || this.amorpm4 == false) {
      this.amorpm4 = false;
    }
    if (finalAmPm == 'PM' || this.amorpm4 == true) {
      this.amorpm4 = true;
    }

    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  openPopoverMaintenanceEnd(popover, event) {
    console.log(event);

    this.endTimePlaceholderMaint =
      ('0' + (event.hour > 12 ? event.hour - 12 : event.hour == 0 ? 12 : event.hour)).slice(-2) +
      ':' +
      ('0' + event.minute).slice(-2) +
      ' ' +
      (event.hour > 12 || this.amorpm5 ? 'PM' : 'AM');

    //additional adding
    let firstPlaceHolder = this.endTimePlaceholderMaint.split(':');
    let splitedfirstPlaceHolder = firstPlaceHolder[0];
    console.log(splitedfirstPlaceHolder);
    let splitAmPm = firstPlaceHolder[1].split(' ');
    let miniutePlaceHolder = splitAmPm[0];
    console.log(miniutePlaceHolder);
    let finalAmPm = splitAmPm[1];
    console.log(finalAmPm);

    this.endTimeMaintenance = { hour: parseInt(splitedfirstPlaceHolder), minute: parseInt(miniutePlaceHolder) };
    if (finalAmPm == 'AM' || this.amorpm5 == false) {
      this.amorpm5 = false;
    }
    if (finalAmPm == 'PM' || this.amorpm5 == true) {
      this.amorpm5 = true;
    }

    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  public updateSelectedDateMaintennance(date: NgbDate) {
    this.time1 = true;
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.selectedDateMainten = this.convertFormat(date.year, date.month, date.day);
    this.formatDateMainten = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
    this.selectFromDateMt = this.datepipe.transform(jsDate, 'YYYY-MM-dd');
    console.log(this.selectFromDateMt);
  }

  public updateSelectedToDateMaintennance(date: NgbDate) {
    this.time2 = true;
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.selectedToDateMainten = this.convertFormat(date.year, date.month, date.day);
    this.formatToDateMainten = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
    this.selectToDateMt = this.datepipe.transform(jsDate, 'YYYY-MM-dd');
    console.log(this.selectToDateMt);
  }

  public checkDailyMaintenanceTime() {
    console.log(this.startTimePlaceholder);
    const [hours1, minutes1, period1] = this.startTimePlaceholder.split(/:| /);
    const [hours2, minutes2, period2] = this.endTimePlaceholder.split(/:| /);

    let totalMinutes1 = parseInt(hours1) * 60 + parseInt(minutes1);
    let totalMinutes2 = parseInt(hours2) * 60 + parseInt(minutes2);

    if (period1 === 'PM' && hours1 !== '12') {
      totalMinutes1 += 12 * 60;
    } else if (period1 === 'AM' && hours1 === '12') {
      totalMinutes1 = 0;
    }

    if (period2 === 'PM' && hours2 !== '12') {
      totalMinutes2 += 12 * 60;
    } else if (period2 === 'AM' && hours2 === '12') {
      totalMinutes2 = 0;
    }

    const differenceInMinutes = Math.abs(totalMinutes2 - totalMinutes1);
    const differenceInHours = differenceInMinutes / 60;

    return differenceInHours;
  }

  public checkHourlyRateTime() {
    console.log(this.startTimePlaceholder);
    const [hours1, minutes1, period1] = this.finalDailyStartTime.split(/:| /);
    const [hours2, minutes2, period2] = this.finalDailyEndTime.split(/:| /);

    let totalMinutes1 = parseInt(hours1) * 60 + parseInt(minutes1);
    let totalMinutes2 = parseInt(hours2) * 60 + parseInt(minutes2);

    if (period1 === 'PM' && hours1 !== '12') {
      totalMinutes1 += 12 * 60;
    } else if (period1 === 'AM' && hours1 === '12') {
      totalMinutes1 = 0;
    }

    if (period2 === 'PM' && hours2 !== '12') {
      totalMinutes2 += 12 * 60;
    } else if (period2 === 'AM' && hours2 === '12') {
      totalMinutes2 = 0;
    }

    const differenceInMinutes = Math.abs(totalMinutes2 - totalMinutes1);
    const differenceInHours = differenceInMinutes / 60;

    return differenceInHours;
  }

  public checkRateCardMaintenanceTimeSum(startTime: any, endTime: any) {
    const [hours1, minutes1, period1] = startTime.split(/:| /);
    const [hours2, minutes2, period2] = endTime.split(/:| /);

    let totalMinutes1 = parseInt(hours1) * 60 + parseInt(minutes1);
    let totalMinutes2 = parseInt(hours2) * 60 + parseInt(minutes2);

    if (period1 === 'PM' && hours1 !== '12') {
      totalMinutes1 += 12 * 60;
    } else if (period1 === 'AM' && hours1 === '12') {
      totalMinutes1 = 0;
    }

    if (period2 === 'PM' && hours2 !== '12') {
      totalMinutes2 += 12 * 60;
    } else if (period2 === 'AM' && hours2 === '12') {
      totalMinutes2 = 0;
    }

    const differenceInMinutes = Math.abs(totalMinutes2 - totalMinutes1);
    const differenceInHours = differenceInMinutes / 60;

    return differenceInHours;
  }

  toggleSelection(item: any) {
    // this.weekNameArray = [];
    console.log(item);
    if (item.selected === false) {
      this.weekNameArray.push(item.id);
    } else {
      // this.weekNameArray.slice(item.id);
      this.weekNameArray = this.weekNameArray.filter(e => e !== item.id);
    }
    console.log(this.weekNameArray);
    item.selected = !item.selected;
  }

  checkhourRateValue(data: { hourRate: any; }, index: any) {
    if (data[index].hourRate != null) {
      this.error[data[index].hourRate + index] = false;
      this.errorText = '';
    } else {
      this.error[data[index].hourRate + index] = true;
    }
  }

  formatDateAll(dateString) {
    const parts = dateString.split('-');
    const year = parts[0];
    const month = parts[1].padStart(2, '0'); // padStart adds leading zero if necessary
    const day = parts[2].padStart(2, '0'); // padStart adds leading zero if necessary
    return `${year}-${month}-${day}`;
  }

  getDateinNgbFormat(date) {
    let dt = (date.split('T')[0]).split('-')
    let fDate = {
      year: parseInt(dt[0]),
      month: parseInt(dt[1]),
      day: parseInt(dt[2])
    }
    console.log('fDate', fDate)
    return fDate
  }

  convertTo12HourFormat(timeString) {
    const [hours24, minutes, seconds] = timeString.split(':');
    let hours12 = parseInt(hours24, 10);
    const ampm = hours12 >= 12 ? 'PM' : 'AM';
    hours12 = hours12 % 12 || 12; // Convert 0 to 12 for 12-hour clock
    return `${hours12}:${minutes} ${ampm}`;
  }

  convertToHourMinuteObject(timeString) {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    return { hour: parseInt(hours), minute: parseInt(minutes) };
  }

  formatDateForMaintenance(inputDate) {
    const date = new Date(inputDate);

    // Get day, month, and year from the input date
    const day = date.getDate();
    let month = date.toLocaleString('default', { month: 'short' }); // Get short month name
    month = month.substring(0, 3); // Limit the month name to the first three characters
    const year = date.getFullYear();

    // Construct the desired format
    const formattedDate = `${day} ${month}, ${year}`;

    return formattedDate;
  }

  isDifferenceMoreThanOneYear(date1: any, date2: any) {
    const oneYearInMilliseconds = 365 * 24 * 60 * 60 * 1000; // Number of milliseconds in a year
    const differenceInMilliseconds = Math.abs(new Date(date1).getTime() - new Date(date2).getTime());

    const differenceInYears = differenceInMilliseconds / oneYearInMilliseconds;

    return differenceInYears > 1;
  }

  formatDateToDateString(dateString) {
    return dateString.substring(0, 10);
  }

  allDayCheckTime(event) {
    if (this.isAllDay) {
      this.timeFieldDisabled = true;
      // if (this.meetingRoomId == null) {
      //   this.startTimePlaceholderMaint = "07:00 AM";
      //   this.endTimePlaceholderMaint = "07:00 PM";
      //   this.amorpm4 = false;
      //   this.amorpm5 = true;
      // } else if (this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail.length == 0) {
      //   this.startTimePlaceholderMaint = "07:00 AM";
      //   this.endTimePlaceholderMaint = "07:00 PM";
      //   this.amorpm4 = false;
      //   this.amorpm5 = true;
      // }

      // if (this.meetingRoomId == null) {
      //   this.startTimePlaceholderMaint = "07:00 AM";
      //   this.endTimePlaceholderMaint = "07:00 PM";
      //   this.amorpm4 = false;
      //   this.amorpm5 = true;

      //   this.startTimeMaintenance = { hour: 7, minute: 0 };
      //   this.endTimeMaintenance = { hour: 7, minute: 0 };
      // } else if (this.MeetingRoomDetails.parkMeetingRoomMaintainanceDetail.length == 0) {
      //   this.startTimePlaceholderMaint = "07:00 AM";
      //   this.endTimePlaceholderMaint = "07:00 PM";
      //   this.amorpm4 = false;
      //   this.amorpm5 = true;

      //   this.startTimeMaintenance = { hour: 7, minute: 0 };
      //   this.endTimeMaintenance = { hour: 7, minute: 0 };
      // } else {
      //   this.startTimePlaceholderMaint = this.startTimePlaceholder; // "07:00 AM";
      //   this.endTimePlaceholderMaint = this.endTimePlaceholder; // "07:00 PM";
      //   this.amorpm4 = false;
      //   this.amorpm5 = true;

      //   this.startTimeMaintenance = this.convertTimeToHourMinute(this.startTimePlaceholder); // { hour: 7, minute: 0 };
      //   this.endTimeMaintenance = this.convertTimeToHourMinute(this.endTimePlaceholder); // { hour: 7, minute: 0 };
      // }

      if (this.TempRateCardHourCal[0].stimerate != null && this.TempRateCardHourCal[0].etimerate != null) {
        this.startTimePlaceholderMaint = this.startTimePlaceholder; // "07:00 AM";
        this.endTimePlaceholderMaint = this.endTimePlaceholder; // "07:00 PM";
        this.amorpm4 = false;
        this.amorpm5 = true;
      } else {
        this.startTimePlaceholderMaint = "12:00 AM";
        this.endTimePlaceholderMaint = "11:59 PM";
        this.amorpm4 = false;
        this.amorpm5 = true;
      }

      this.startTimeMaintenance = this.convertTimeToHourMinute(this.startTimePlaceholderMaint); // { hour: 7, minute: 0 };
      this.endTimeMaintenance = this.convertTimeToHourMinute(this.endTimePlaceholderMaint); // { hour: 7, minute: 0 };
    } else {
      this.timeFieldDisabled = false;
    }
  }

  convertTimeToHourMinute(timeString) {
    // Split the time string into hours, minutes, and period (AM/PM)
    const [time, period] = timeString.split(' ');

    // Split the time into hours and minutes
    const [hours, minutes] = time.split(':').map(Number);

    // Convert hours to 24-hour format if it's PM and not already 12 PM
    const hour = period === 'PM' && hours !== 12 ? hours + 12 : hours;

    // Return an object containing hour and minute
    return { hour, minute: minutes };
  }

  addOneHour(timeString) {
    // Split the time string into hours, minutes, and period (AM/PM)
    const [time, period] = timeString.split(' ');

    // Split the time into hours and minutes
    const [hours, minutes] = time.split(':').map(Number);

    // Add 1 hour to the hours component
    let updatedHours = (hours + 1) % 12;
    updatedHours = updatedHours === 0 ? 12 : updatedHours; // Convert 0 to 12 for 12 AM/PM

    // Determine the updated period (AM/PM)
    const updatedPeriod = (hours + 1 < 12) ? period : (period === 'AM' ? 'PM' : 'AM');

    // Construct the updated time string
    const updatedTime = `${updatedHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${updatedPeriod}`;

    return updatedTime;
  }

  addOneHourTimeFormat({ hour, minute }) {
    // Create a new Date object with the given hour and minute
    const time = new Date(2000, 0, 1, hour, minute);

    // Add 1 hour to the time
    time.setHours(time.getHours() + 1);

    // Get the updated hour and minute
    const updatedHour = time.getHours();
    const updatedMinute = time.getMinutes();

    // Return the updated time object
    return { hour: updatedHour, minute: updatedMinute };
  }

  isEndTimeGreaterThanStartTime(startTime, endTime) {
    // Convert time strings to 24-hour format for comparison
    const startTime24 = this.convertTo24HourFormat(startTime);
    const endTime24 = this.convertTo24HourFormat(endTime);

    // Compare the times
    return startTime24 < endTime24;
  }

  convertTo24HourFormat(timeString) {
    const [time, period] = timeString.split(' ');

    let [hours, minutes] = time.split(':').map(Number);

    if (period === 'PM' && hours !== 12) {
      hours += 12; // Convert PM to 24-hour format
    } else if (period === 'AM' && hours === 12) {
      hours = 0; // Convert 12 AM to 0 hours
    }

    return hours * 60 + minutes; // Convert hours and minutes to total minutes
  }

  scrollToFirstInvalidField() {
    if (this.myForm && this.myForm.nativeElement) {
      const invalidControl = this.myForm.nativeElement.querySelector('.ng-invalid');
      console.log(invalidControl);
      if (invalidControl) {
        invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    firstInvalidControl.focus(); //without smooth behavior
  }

  getAllAminities() {
    this.meetingService.getAllAmenities().subscribe(res => {
      this.amentities = res?.list;
      console.log(this.amentities);
    });
  }

  addAmentity(item) {
    console.log(item);
    if (this.selectedAminity.indexOf(item.amenitiesId) > -1) {
      this.selectedAminity.splice(this.selectedAminity.indexOf(item.amenitiesId), 1);
    } else {
      this.selectedAminity.push(item.amenitiesId);
    }

    this.parkMeetingRoomAmenities = this.selectedAminity.map(id => ({
      "AmenitiesId": id
    }));

    console.log(this.selectedAminity);
  }

  validateImageDimensions(imageSrc: string) {
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      if (img.width !== 1080 || img.height !== 608) {
        return this.appStateSrv.showToast('Image dimensions should be 1080 px X 608 px');
      } else {
        this.previewUrl = this.sanitizer.bypassSecurityTrustUrl(imageSrc);
        this.errorMessage = '';
      }
    };
  }

  // Method to check if an amenity is selected
  isSelected(amenitiesId: string): boolean {
    return this.selectedAminity.includes(amenitiesId);
  }

  getMyCompanyDetails() {
    this.companyService.getMyCompanyDetails(this.parkTenantId, this.parkId).subscribe(
      (response: any) => {
        if (response.isValid && response.data != null) {
          console.log(response.data.employees);
          this.myCompanyData = response.data;
          this.employeeList = this.myCompanyData?.employees;
          this.employeeListActive = this.myCompanyData?.employees.filter((user) => user.isApproved === true && user.isVerified === true && (user.employeeRole === 'ParkAdmin' || user.employeeRole === 'ParkCoAdmin'));
          console.log(this.employeeListActive);
        } else {
          // this.isLoaded = true
        }
      }
    );
  }

  getCurrentTime(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    // Add leading zero to hours and minutes if they are less than 10
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    let strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  formatTime(timeStr) {
    // Split the time into parts: hours, minutes, and AM/PM
    let [time, period] = timeStr.split(' ');
    let [hours, minutes] = time.split(':');

    // Add leading zero to the hours if less than 10
    hours = hours.length < 2 ? '0' + hours : hours;

    return `${hours}:${minutes} ${period}`;
  }

  formatDateTimezone(dateString) {
    let date = new Date(dateString);
    let year = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    let day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  getCurrentDate() {
    let date = new Date();
    let year = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    let day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  getAminityIcon(id) {
    let imageUrl = '';
    switch (id) {
      case '8985509e-5193-43d5-be78-12554aeb8ad8':
        imageUrl = '../../../assets/amentities/cinemas.png';
        break;
      case '6e8098aa-9cb1-493c-927c-21c81e359536':
        imageUrl = '../../../assets/amentities/Food Courts-1@3x.png';
        break;
      case '41dc875b-71ce-4487-8892-aa37d171b505':
        imageUrl = '../../../assets/amentities/Telecom Operator-1@3x.png';
        break;
      case '9e4cce68-f922-40b7-b212-e59822f523c7':
        imageUrl = '../../../assets/amentities/cinemas.png';
        break;
    }
    return imageUrl;
  }

  hasWhitespaceAtStartOrEnd(text) {
    const regex = /^\s+|\s+$/;
    return regex.test(text);
  }

  onInput(event: any): void {
    const input = event.target.value;

    // Convert the input to an integer and ensure it's greater than 0
    const value = parseInt(input, 10);

    // If input is not a number or less than 1, set the value to null or empty string
    if (isNaN(value) || value <= 0) {
      this.capacity = null;  // Optionally, clear the input
    } else {
      this.capacity = value;
    }
  }

  validateNumber(event: KeyboardEvent): void {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

    // Prevent any key that's not a number or an allowed control key
    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
}

